// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:55.164Z
// Property: Mission Point (ID: 6767906449165611)
// Collections: 28 amenities, 12 floorplans (live), 27 photos, 70 POIs, 2 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165611",
  "property_external_id": "hhfvgt1",
  "property_zillow_url": "https://www.zillow.com/homedetails/2900-S-Service-Rd-Moore-OK-73160/245290682_zpid/",
  "property_apartments_url": "https://www.apartments.com/mission-point-moore-ok/hhfvgt1/",
  "property_google_business_url": "https://www.google.com/maps/place/Mission+Point+Apartments/data=!4m2!3m1!1s0x0:0xf4be068136da9f36?sa=X&ved=2ahUKEwjuosaM-7ySAxXsBdsEHS2HNXsQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mission-point",
  "property_name": "Mission Point",
  "property_website_url": "https://www.caseusa.com/apartments/ok/moore/mission-point/",
  "property_domain": null,
  "property_address": "2900 South Service Road",
  "property_full_address": "2900 South Service Road, Moore, OK, 73160",
  "property_address_1": "2900 South Service Road",
  "property_address_2": null,
  "property_address_city": "Moore",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73160",
  "property_address_country": "US",
  "property_address_county": "Cleveland County",
  "property_neighborhood_address": "Outer Norman",
  "property_address_latitude": "35.3117",
  "property_address_longitude": "-97.4873",
  "property_email": "missionpoint@caseusa.com",
  "property_phone": "(405) 242-1223",
  "property_call_tracking_phone": "833-767-7710",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Mission Point in Moore, Oklahoma, experience the perfect blend of comfort and style. Choose from spacious one- and two-bedroom floor plans, enjoy a refreshing dip in the pool, or unwind in our vibrant clubhouse. With amenities like a pet play area and walking trails, your ideal lifestyle awaits. Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Mission Point, the prestigious apartment community in Moore, Oklahoma, where comfort meets convenience! Offering a range of spacious floor plans, including one-bedroom and two-bedroom apartments, you are sure to find the perfect space to call home. Our elegant residences boast desirable features such as vaulted ceilings, walk-in closets, and modern stainless steel appliances, all designed to cater to your lifestyle.\n\nAt Mission Point, you'll discover a wealth of exceptional amenities that elevate your living experience. Relax and unwind in our stunning pool or soak up the sun on the sundeck, perfect for those warm Oklahoma days. Stay active in our state-of-the-art fitness center or enjoy the great outdoors on our scenic walking and biking trails. Socialize with neighbors in the inviting clubhouse or attend our planned social activities, fostering a true sense of community.\n\nYour security and convenience is our priority, with controlled access, gated entry, and on-site maintenance and management teams dedicated to ensuring your comfort. With additional amenities such as a dog park, pet play area, and maintenance on-site, Mission Point is truly pet-friendly.\n\nDon’t miss out on this exceptional living experience! Our apartments come equipped with essential features like air conditioning, washer/dryer hookups, and spacious patios or balconies to enjoy breathtaking views. \n\nFind your new home today at Mission Point! Browse our availability or schedule a tour to visit our vibrant community. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-1551-7489-a7ce-dfb5b9c3de6a.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of Mission Point apartment complex with a golf cart and car parked in front of the building.",
    "public_id": "019cfb42-1551-7489-a7ce-dfb5b9c3de6a",
    "storage_key": "property/6767906449165611/019cfb42-1551-7489-a7ce-dfb5b9c3de6a.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "628",
  "property_year_built": "2015",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.08917197452229",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Dogs and cats allowed (certain breed restrictions apply), no weight limit. Maximum of two pets per home.",
  "property_pet_policy_description": "Dogs and cats allowed (certain breed restrictions apply), no weight limit. Maximum of two pets per home. One-time non‑refundable fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://missionpointapartmentsmoore.securecafe.com/onlineleasing/mission-point-1-0/floorplans.aspx",
  "property_resident_portal_url": "https://missionpointapartmentsmoore.securecafe.com/residentservices/mission-point-1-0/userlogin.aspx",
  "property_apply_now_url": "https://missionpointapartmentsmoore.securecafe.com/onlineleasing/mission-point-1-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-47f4-73ed-b4af-f7e27882e339.webp",
  "property_primary_logo_media": {
    "alt_text": "Mission Point Luxury Apartments logo.",
    "public_id": "019cfb42-47f4-73ed-b4af-f7e27882e339",
    "storage_key": "property/6767906449165611/019cfb42-47f4-73ed-b4af-f7e27882e339.webp",
    "width": 300,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb43-4787-76d3-af15-4b72aef20f84.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb43-4787-76d3-af15-4b72aef20f84",
    "storage_key": "property/6767906449165611/019cfb43-4787-76d3-af15-4b72aef20f84.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb43-6aba-746e-b98c-e0c49c6a604f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Mission Point Luxury Apartments logo",
    "public_id": "019cfb43-6aba-746e-b98c-e0c49c6a604f",
    "storage_key": "property/6767906449165611/019cfb43-6aba-746e-b98c-e0c49c6a604f.webp",
    "width": 300,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb43-73f5-71bf-99f2-1767ed7237ff.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Mission Point Luxury Apartments logo",
    "public_id": "019cfb43-73f5-71bf-99f2-1767ed7237ff",
    "storage_key": "property/6767906449165611/019cfb43-73f5-71bf-99f2-1767ed7237ff.webp",
    "width": 300,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#16618e",
  "property_secondary_color": "#000000",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1176",
  "property_sqft_min": "789",
  "property_sqft_max": "1176",
  "property_price_range": "1129 - 1409",
  "property_price_min": "1129",
  "property_price_max": "1409",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/MissionPointApts/photos/d41d8cd9/1533293244925252/",
  "property_instagram_url": "https://www.instagram.com/missionpointapts/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ2zKDgBhrsocRNp_aNoEGvvQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?cflt=apartments&find_near=mission-point-i-and-ii-moore",
  "property_tiktok_url": "https://www.tiktok.com/@missionpoint",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Mission Point",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today!",
  "property_home_amenities_blurb": "At Mission Point in Moore, Oklahoma, your ideal home awaits. Choose from our beautifully designed one and two-bedroom apartments, complete with modern amenities like stainless steel appliances and spacious walk-in closets. Enjoy resort-style living with a refreshing pool, pet-friendly parks, and vibrant social activities—all tailored for your lifestyle.",
  "property_home_floorplans_blurb": "At Mission Point in Moore, Oklahoma, your ideal apartment awaits! With stylish one and two-bedroom floor plans designed for modern living, each space offers comfort and sophistication. Uncover the perfect backdrop for your lifestyle—where convenience meets charm. Browse our available apartment homes today and envision your new beginning!",
  "property_home_gallery_blurb": "At Mission Point in Moore, Oklahoma, your ideal lifestyle awaits. Choose from spacious one or two-bedroom layouts, complete with stunning views and modern amenities. Unwind by the pool, energize in our fitness center, or socialize in the clubhouse. Picture yourself living here, where comfort meets convenience!",
  "property_home_neighborhood_blurb": "At Mission Point in Moore, Oklahoma, your new home is surrounded by vibrant attractions. Unwind at nearby parks like Ruby Grant Park or enhance your fitness routine at Four Star Fitness. With easy access to educational hubs like Mid-America Christian University and the Museum of Osteology, life's adventures await!",
  "property_home_reviews_blurb": "At Mission Point in Moore, Oklahoma, residents rave about their living experience, praising our \"phenomenal upkeep\" and the attentive, \"kind\" staff who address every concern with care. With beautiful surroundings and a welcoming community, it's no wonder families are excited to call this place home. Join us today!",
  "property_neighborhood_blurb": "Nestled in the heart of Moore, Oklahoma, Mission Point offers easy access to vibrant community highlights. Enjoy the outdoors at Earlywine Park YMCA and Buck Thomas Park, or indulge in learning at the Museum of Osteology. Uncover local gems and vibrant activities just steps from your new home.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Mission Point in Moore, Oklahoma, your perfect lifestyle awaits! Unwind by our sparkling pool, stay active in the fitness center, or connect with neighbors in the clubhouse. With luxurious apartment features, including walk-in closets and a pet-friendly environment, every moment here feels like home. Come see for yourself!",
  "property_applynow_blurb": "At Mission Point in Moore, Oklahoma, your ideal living space awaits. Choose from spacious one and two-bedroom floor plans, each designed for comfort and style. Enjoy top-notch amenities like a serene pool, vibrant fitness center, and welcoming clubhouse. Connect with nature on nearby trails or relax in your private balcony—apply online today!",
  "property_contactus_blurb": "At Mission Point in Moore, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Embrace comfort and convenience in an inviting community where your perfect home awaits. Have questions? Contact our leasing team today to uncover the possibilities that await you!",
  "property_faqs_blurb": "At Mission Point in Moore, Oklahoma, our thoughtfully designed one and two-bedroom apartments cater to every lifestyle. Curious about our community? Check out our FAQs page for insights on amenities, floor plans, and more. Your questions are just a click away from insightful answers!",
  "property_floorplans_blurb": "At Mission Point in Moore, Oklahoma, your ideal living space awaits! Whether you prefer a cozy one-bedroom or need the extra room of a spacious two-bedroom, our variety of thoughtfully designed floor plans caters to every lifestyle. Browse our available apartment homes and discover your perfect fit today!",
  "property_gallery_blurb": "At Mission Point in Moore, Oklahoma, your ideal lifestyle awaits. Picture vibrant living spaces, from cozy one- and two-bedroom apartments to stunning loft layouts. Enjoy resort-style amenities like a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Join our community and get ready to call this home!",
  "property_interactivemap_blurb": "At Mission Point in Moore, Oklahoma, choose from spacious one- and two-bedroom layouts designed for comfort. Enjoy a vibrant lifestyle with amenities like a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Ready to find your ideal home? Use our interactive community map for pricing and availability!",
  "property_pets_blurb": "At Mission Point in Moore, OK, your furry friends are part of the family! Enjoy spacious living with no weight limits for your beloved dogs and cats. With a pet-friendly atmosphere and nearby parks, your pets will thrive in a community designed for joyful living. Join us today!",
  "property_referafriend_blurb": "At Mission Point in Moore, Oklahoma, your dream apartment awaits—choose from spacious one and two bedroom floor plans tailored for modern living. Share the love of this vibrant community with friends; after all, great friends make great neighbors. Refer a friend today and enhance your Mission Point experience!",
  "property_residentaccess_blurb": "At Mission Point in Moore, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Access your resident portal to effortlessly pay rent, schedule maintenance, and connect with our community. Your next level of convenient living awaits just a click away!",
  "property_reviews_blurb": "At Mission Point in Moore, Oklahoma, residents rave about their living experience. One resident exclaimed, \"This has been one of my best living experiences to date,\" praising our phenomenal upkeep and attentive staff. Join a community where comfort and care unite—read what our residents love about Mission Point!",
  "property_created_at": "1753982386489",
  "property_scheduletour_blurb": "At Mission Point in Moore, Oklahoma, find your perfect haven with our thoughtfully designed one and two-bedroom floor plans. Each apartment blends comfort and style, creating an inviting atmosphere. Curious about life here? Schedule a tour today and hear firsthand experiences from our delighted residents!",
  "property_thankyou_blurb": "Thank you for reaching out to Mission Point in Moore, Oklahoma! We’re excited to help you find the perfect space. Whether you're searching for a cozy one-bedroom or a spacious two-bedroom, our vibrant community awaits. A member of our team will connect with you soon to assist with your journey!",
  "property_virtualtours_blurb": "Welcome to Mission Point in Moore, Oklahoma, where modern living meets comfort. Choose from stylish one or two-bedroom floor plans designed for your lifestyle. Immerse yourself in our vibrant community—take a virtual tour today and envision your next home sweet home! ",
  "property_copyright": "2025 All Rights Reserved. Mission Point",
  "property_seo_title_home": "Mission Point |  Apartments in Moore, Oklahoma",
  "property_seo_description_home": "Experience refined living at Mission Point in Moore, OK! Choose from spacious floor plans, enjoy top-notch amenities, and embrace a vibrant community.",
  "property_seo_title_floorplans": "Floor Plans | Moore, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal floor plan at Mission Point in Moore, OK! Choose from stylish one and two-bedroom apartments. Your perfect home awaits—browse now!",
  "property_seo_title_amenities": "Amenities | Moore, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Embrace the lifestyle at Mission Point, Moore! Enjoy our luxurious pool, fitness center, and pet-friendly spaces. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Moore, Oklahoma",
  "property_seo_description_gallery": "Picture life at Mission Point in Moore, OK! Enjoy modern amenities, stunning views, and a vibrant community. Your ideal apartment awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Mission Point Apartments",
  "property_seo_description_virtualtours": "Step inside Mission Point in Moore, OK! Take a virtual tour of our stylish one and two-bedroom apartments and feel at home today. Your perfect space awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Mission Point Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Mission Point in Moore, OK. Use our interactive map to view available apartments and amenities designed for comfortable living!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Moore, Oklahoma",
  "property_seo_description_neighborhood": "Experience life at Mission Point in Moore, OK! Discover vibrant local favorites and exciting points of interest just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Mission Point",
  "property_seo_description_contact": "Find your perfect home at Mission Point in Moore, OK! Inquire about our inviting one and two-bedroom floor plans. Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Moore, Oklahoma",
  "property_seo_description_faqs": "Find all the answers you seek at Mission Point in Moore, OK! Browse our FAQs for insights into our amenities, floor plans, and community life.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Moore, Oklahoma",
  "property_seo_description_reviews": "Join the vibrant life at Mission Point in Moore, OK! Our residents love the amazing amenities. Dive into their experiences and find your perfect home today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Moore, Oklahoma",
  "property_seo_description_applynow": "Find your ideal lifestyle at Mission Point in Moore! Enjoy luxury living with top-tier amenities, spacious layouts, and a vibrant community. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Mission Point",
  "property_seo_description_residentaccess": "Access your Mission Point resident portal for seamless rent payments, hassle-free maintenance requests, and all your community needs—right at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Mission Point",
  "property_seo_description_referafriend": "At Mission Point in Moore, OK, great friends build a vibrant community. Refer a friend today and enjoy the perks of living together in style!",
  "property_seo_title_scheduletour": "Schedule a Tour | Mission Point",
  "property_seo_description_scheduletour": "Experience the charm of Mission Point in Moore, OK! Schedule your tour today and envision your new home in our vibrant community filled with modern amenities.",
  "property_seo_title_privacy": "Privacy Policy | Mission Point",
  "property_seo_description_privacy": "At Mission Point in Moore, OK, your privacy matters. Read our policy to learn how we protect your personal information while you enjoy our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | Mission Point",
  "property_seo_description_accessibility": "Experience digital inclusion at Mission Point in Moore, Oklahoma. Our commitment ensures everyone can enjoy seamless access to all our community features.",
  "property_seo_title_sitemap": "Sitemap | Mission Point",
  "property_seo_description_sitemap": "Explore Mission Point in Moore, OK! Our sitemap guides you to amenities, floor plans, and community features to make it your home.",
  "property_seo_title_thankyou": "Thank You | Mission Point",
  "property_seo_description_thankyou": "Thank you for your interest in Mission Point! A team member will be in touch soon to help you discover your new home in Moore, OK. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Moore, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865392919",
  "amenities": [
    {
      "id": "custom_d3a5bcc2-c594-4afc-ad14-6602298fc36b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Barbecue & Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1cab313-a19a-48ac-9a69-638881a39c34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_604a2ff0-d9c5-4d97-8d3e-453e106f2be6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5de8cfc5-8208-4049-a71f-c00a7c2f1aa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Fitness & Health Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88dcd6b7-156c-4979-924f-b6e377e9d22b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e852df7f-43df-4611-8f8c-3deb1e48f4e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af4fdfe2-3ff8-4958-8f4a-6fb8b812d62d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Professional Onsite Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a4a8b714-67ed-4a70-a1a0-423335ed5cd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Style Swimming Pool with Grill & Chill Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8bfba7ac-46cd-4f2f-8ccc-1ff60547de3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Short‑Term Lease Available with Upcharge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_016389c4-9469-49ba-ae42-07b28b729b79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b398d091-df1e-4d42-a061-01209de8aa19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Dog Parks",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1e66870-c355-40cb-bff3-ba62a0e06e2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59eb1018-550c-418c-8ed8-7e27ba9d8f15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Fire Pit & Lounge Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_32a8b9c8-1454-4891-ae42-fac734c601d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1839599a-b9e1-4437-b6b1-caac07cfa053",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Electronic Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27f28670-e5a4-42b0-a2a6-bb593257537b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42590224-82f8-4613-805d-b013e807ac49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd03a0bd-964f-46b8-9f19-80e7713e3b2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bdb43fb9-8cdd-4f90-b1ad-e204e0973b76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Stainless‑Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2179f39b-77eb-4ba5-b4b4-848b12270233",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplaces*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5984f5da-5d32-47e3-bcc3-63aeec5ecc0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Ceramic Tile",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe0bc6c6-78c7-4d92-bd09-b36e19f6d306",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0232a96a-a416-40e0-932e-273093629cfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_983c4c1e-e505-413e-b26c-fa3065509537",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchens",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fabad595-cdfe-4b93-81ca-04755c60c3ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Unique Floor Plan with Extra Dining or Office Nook*",
      "amount": "false",
      "description": "*In select homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc3ab350-9696-4cd7-abb5-9b01e084079d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Paint with Accent Wall",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0ecd3f26-660b-484a-9b24-e533e11c5be6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Individual Climate Control",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36a523d1-40a2-47ac-af78-f877e7ece687",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "external_id": "false",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ce21fd80-200c-41f1-84fd-e7ec29fe6a47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-328d-706e-8630-8a98c632dd4a.webp",
      "image_media": {
        "alt_text": "Exterior view of Mission Point community entrance with stone arches and a tall sign.",
        "public_id": "019d20af-328d-706e-8630-8a98c632dd4a",
        "storage_key": "property/6767906449165611/019d20af-328d-706e-8630-8a98c632dd4a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior of the Mission Point apartment community, featuring a stone façade, arched entrances, and landscaped grounds.",
      "link": "",
      "alt_text": "Exterior view of Mission Point community entrance with stone arches and a tall sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-1551-7489-a7ce-dfb5b9c3de6a.webp"
    },
    {
      "id": "custom_66271e25-38cd-4227-8a25-d5ada1a0b977",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-3365-7433-a183-8116a68285b3.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with lounge chairs and surrounding apartment buildings.",
        "public_id": "019d20af-3365-7433-a183-8116a68285b3",
        "storage_key": "property/6767906449165611/019d20af-3365-7433-a183-8116a68285b3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Sunlit community pool with seating and clubhouse, flanked by multi-story apartment buildings.",
      "link": "",
      "alt_text": "Outdoor pool area with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WNLLxU8KyBNNJG_TulYa8QNXxyTUucKeYArmSkGuzw0/116/image.jpg"
    },
    {
      "id": "custom_0c0a14d8-a86a-423a-9185-984a7c535571",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-328e-71f9-9d59-715251133fd6.webp",
      "image_media": {
        "alt_text": "Outdoor pool deck at a multifamily community with lounge chairs and surrounding buildings.",
        "public_id": "019d20af-328e-71f9-9d59-715251133fd6",
        "storage_key": "property/6767906449165611/019d20af-328e-71f9-9d59-715251133fd6.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Relax by the community pool surrounded by modern apartment buildings and ample lounge seating.",
      "link": "",
      "alt_text": "Outdoor pool deck at a multifamily community with lounge chairs and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165611/019cfb42-4830-720c-a7a9-906ba87fd713.webp"
    },
    {
      "id": "custom_493468a5-611c-4536-8430-b0347c23ccc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-32c2-76aa-a2f4-c3716a4b6211.webp",
      "image_media": {
        "alt_text": "Open grassy community lawn with a small playground and surrounding wooden fence.",
        "public_id": "019d20af-32c2-76aa-a2f4-c3716a4b6211",
        "storage_key": "property/6767906449165611/019d20af-32c2-76aa-a2f4-c3716a4b6211.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Spacious outdoor community space with a playground for residents to enjoy.",
      "link": "",
      "alt_text": "Open grassy community lawn with a small playground and surrounding wooden fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3wnjee5D70mcAtEH1aXe88q6etPukflLRdStEIAuNwE/116/image.jpg"
    },
    {
      "id": "custom_c2681c11-343c-435c-a2e1-b9eabb424b8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-f17d-76ec-accd-1feb9d9bb106.webp",
      "image_media": {
        "alt_text": "Exterior view of beige apartment buildings with balconies and a fenced grassy courtyard.",
        "public_id": "019cfb42-f17d-76ec-accd-1feb9d9bb106",
        "storage_key": "property/6767906449165611/019cfb42-f17d-76ec-accd-1feb9d9bb106.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of a multi-building community with balconies and a fenced grassy courtyard, showcasing family-friendly living.",
      "link": "",
      "alt_text": "Exterior view of beige apartment buildings with balconies and a fenced grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/PIz-C3yqMI4DBHXSJimy4RzL6D7C_xJs_k9WtiZBzUU/116/image.jpg"
    },
    {
      "id": "custom_b04bfd3c-24d9-453d-b55e-17a158f3bdb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-3d5c-71bc-994d-db2b384b3036.webp",
      "image_media": {
        "alt_text": "Interior of a communal computer center with desks, monitors, and office chairs.",
        "public_id": "019d20af-3d5c-71bc-994d-db2b384b3036",
        "storage_key": "property/6767906449165611/019d20af-3d5c-71bc-994d-db2b384b3036.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Bright community computer center for residents, featuring multiple workstations, a printer, and contemporary decor.",
      "link": "",
      "alt_text": "Interior of a communal computer center with desks, monitors, and office chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165611/019cfb42-486f-72d3-befa-e6a2bf59a237.webp"
    },
    {
      "id": "custom_b54c7db3-158b-4bfe-a452-efa0ff668a2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-3efe-753d-b13b-8be806c80aa5.webp",
      "image_media": {
        "alt_text": "Bright community gym with treadmills, weights, and a rack of exercise balls.",
        "public_id": "019d20af-3efe-753d-b13b-8be806c80aa5",
        "storage_key": "property/6767906449165611/019d20af-3efe-753d-b13b-8be806c80aa5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "On-site fitness center featuring cardio machines, free weights, and a rack of stability balls for residents.",
      "link": "",
      "alt_text": "Bright community gym with treadmills, weights, and a rack of exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Jphru91CwKQQeV4tCe_lejhgW2JdXNWEgJ8dK8el2FM/116/image.jpg"
    },
    {
      "id": "custom_41a17c2b-25d7-453b-8f99-4d47b8097b71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-405f-7743-b9aa-160d5064ffc5.webp",
      "image_media": {
        "alt_text": "Bright community gym with weight machines, free weights, cardio bike, and large windows.",
        "public_id": "019d20af-405f-7743-b9aa-160d5064ffc5",
        "storage_key": "property/6767906449165611/019d20af-405f-7743-b9aa-160d5064ffc5.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Our on-site fitness center features a variety of strength and cardio equipment in a bright, open space.",
      "link": "",
      "alt_text": "Bright community gym with weight machines, free weights, cardio bike, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165611/019cfb42-4831-7608-9e83-c9edb1f62b1a.webp"
    },
    {
      "id": "custom_3eb3d62c-1910-4b5e-9e79-16a726f8fb84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-4127-72f3-92ba-7ef517e1bdc1.webp",
      "image_media": {
        "alt_text": "Bright communal fitness center with weight machines, kettlebells, medicine balls, and cardio equipment.",
        "public_id": "019d20af-4127-72f3-92ba-7ef517e1bdc1",
        "storage_key": "property/6767906449165611/019d20af-4127-72f3-92ba-7ef517e1bdc1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern community gym at the apartment complex with strength and cardio equipment for residents.",
      "link": "",
      "alt_text": "Bright communal fitness center with weight machines, kettlebells, medicine balls, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OUVEleW2f8dcK_R-14e90BX8oi0rwMAwzM68f5pzeoE/116/image.jpg"
    },
    {
      "id": "custom_c9061a0d-01b4-4c63-9d11-0bd8cf075d55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-49a6-7099-8253-4ea15ce68580.webp",
      "image_media": {
        "alt_text": "Open-concept living area with beige walls, carpet, a brown leather sofa, and a kitchen bar in the background.",
        "public_id": "019d20af-49a6-7099-8253-4ea15ce68580",
        "storage_key": "property/6767906449165611/019d20af-49a6-7099-8253-4ea15ce68580.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area with a modern kitchen, bar seating, and a brown leather sectional—great for entertaining.",
      "link": "",
      "alt_text": "Open-concept living area with beige walls, carpet, a brown leather sofa, and a kitchen bar in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jlnklCiya6lSdr451E3Z6DWyAW-bOvG0pQGX9J3L1Xw/116/image.jpg"
    },
    {
      "id": "custom_c8fa4723-e7e9-403f-bec2-6893e49f919d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-4bba-731b-85fa-14a92ea986d6.webp",
      "image_media": {
        "alt_text": "Interior of an apartment living/dining space with a dark accent wall, desk, framed art, and large windows.",
        "public_id": "019d20af-4bba-731b-85fa-14a92ea986d6",
        "storage_key": "property/6767906449165611/019d20af-4bba-731b-85fa-14a92ea986d6.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern décor, natural light from large windows, and a contemporary workspace.",
      "link": "",
      "alt_text": "Interior of an apartment living/dining space with a dark accent wall, desk, framed art, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/g3Ll1Lau4QNl737MPw_d_sKDNCzSIUBlFGrJhKVJwW4/116/image.jpg"
    },
    {
      "id": "custom_876dc681-1cb9-474a-99c4-450c30187bbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-4ef7-71ea-9c90-8d3b2b95d900.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d20af-4ef7-71ea-9c90-8d3b2b95d900",
        "storage_key": "property/6767906449165611/019d20af-4ef7-71ea-9c90-8d3b2b95d900.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment kitchen with dark cabinetry, granite countertops, stainless steel fridge, microwave, and ample storage.",
      "link": "",
      "alt_text": "Modern apartment kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/c4Y5_X8WYzqIYqt3tiGRi8-5yECR0FeskomO9V_Ok2o/116/image.jpg"
    },
    {
      "id": "custom_e5f3037c-519c-4851-9daa-e135e0a9d04b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-cfc6-716b-bddb-af5339602a53.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, ceiling fan, and doorway to the closet and bathroom.",
        "public_id": "019cfb42-cfc6-716b-bddb-af5339602a53",
        "storage_key": "property/6767906449165611/019cfb42-cfc6-716b-bddb-af5339602a53.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Bright apartment bedroom featuring a large bed, ceiling fan, and access to a nearby closet and bathroom.",
      "link": "",
      "alt_text": "Bedroom with a large bed, ceiling fan, and doorway to the closet and bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EwVbeosFdDWRryJS-veJVxdSo5p_zTEJ1mUsgWGIldg/116/image.jpg"
    },
    {
      "id": "custom_67a5da92-3e40-4a5a-b6dd-2a06b104c898",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-529a-766e-abd0-f19a5ea89a99.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, ceiling fan, and a window with white curtains.",
        "public_id": "019d20af-529a-766e-abd0-f19a5ea89a99",
        "storage_key": "property/6767906449165611/019d20af-529a-766e-abd0-f19a5ea89a99.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright bedroom in a modern apartment with neutral decor and natural light.",
      "link": "",
      "alt_text": "Bedroom with a bed, ceiling fan, and a window with white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k4m_wM_OTol4hXZIAWcmfYV7rqWJaXdHt3GTwASKKdo/116/image.jpg"
    },
    {
      "id": "custom_576bb28a-8f92-4886-9bf2-b2ee2cbfea44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-5785-7618-b72d-e1670ef74944.webp",
      "image_media": {
        "alt_text": "Open-concept living area with a kitchen bar, stools, dining table, and seating.",
        "public_id": "019d20af-5785-7618-b72d-e1670ef74944",
        "storage_key": "property/6767906449165611/019d20af-5785-7618-b72d-e1670ef74944.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with a modern kitchen, breakfast bar, dining area, and comfy seating.",
      "link": "",
      "alt_text": "Open-concept living area with a kitchen bar, stools, dining table, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/d5QYXzCa9A6AEq-gMomLubGKgMZOPqpkPBg3WyasHAc/116/image.jpg"
    },
    {
      "id": "custom_dd5c12be-d06d-4e52-9c31-cd9a799b1c0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-d5e7-771d-bc89-f08032b20fd0.webp",
      "image_media": {
        "alt_text": "Kitchen in an apartment with white cabinets, stainless steel stove and microwave, and dark gray marble countertops.",
        "public_id": "019cfb42-d5e7-771d-bc89-f08032b20fd0",
        "storage_key": "property/6767906449165611/019cfb42-d5e7-771d-bc89-f08032b20fd0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white cabinetry, stainless steel appliances, and marble-look countertops.",
      "link": "",
      "alt_text": "Kitchen in an apartment with white cabinets, stainless steel stove and microwave, and dark gray marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TrYnQP-a6Wwy93bDhcuEhZr_YKCCp6WWYWQRg3xjEgY/116/image.jpg"
    },
    {
      "id": "custom_cdaccb8d-766e-4a8b-a42f-3ab48d6f5c4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-5c84-7199-9db6-b0333c3ffff3.webp",
      "image_media": {
        "alt_text": "Light-filled bedroom with a white wood bed frame, blue bedding, orange throw, ceiling fan, and an open closet.",
        "public_id": "019d20af-5c84-7199-9db6-b0333c3ffff3",
        "storage_key": "property/6767906449165611/019d20af-5c84-7199-9db6-b0333c3ffff3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright bedroom in a modern apartment with a white paneled headboard, blue linens, and an open closet for convenient storage.",
      "link": "",
      "alt_text": "Light-filled bedroom with a white wood bed frame, blue bedding, orange throw, ceiling fan, and an open closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/0CAOYS9JYsFsTWuZR9cXuhx7YAJdkGXYVRpOkObYjxQ/116/image.jpg"
    },
    {
      "id": "custom_ffea041a-e4a5-45cf-b248-f8a7360c3eb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-db93-71b2-bcce-0d9f139bce26.webp",
      "image_media": {
        "alt_text": "Bright living room in an apartment with large windows, a white sofa, and a dining area.",
        "public_id": "019cfb42-db93-71b2-bcce-0d9f139bce26",
        "storage_key": "property/6767906449165611/019cfb42-db93-71b2-bcce-0d9f139bce26.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, modern living space in an apartment with large windows, neutral palette, and a connected dining area.",
      "link": "",
      "alt_text": "Bright living room in an apartment with large windows, a white sofa, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nZ2gz6wcKd8ueNtccnCfRxuyZ3-bZStJVOesOUkaDbs/116/image.jpg"
    },
    {
      "id": "custom_0e303c82-b7a9-49be-b0e8-16b78cb426e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-6100-74a6-89ec-2299b01584ec.webp",
      "image_media": {
        "alt_text": "Dining area in a modern apartment with a wooden table, chairs, a plant, and wall art near a door with blinds.",
        "public_id": "019d20af-6100-74a6-89ec-2299b01584ec",
        "storage_key": "property/6767906449165611/019d20af-6100-74a6-89ec-2299b01584ec.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy dining nook inside a modern apartment featuring a natural wood table, chairs, plant, and abstract wall art.",
      "link": "",
      "alt_text": "Dining area in a modern apartment with a wooden table, chairs, a plant, and wall art near a door with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HWdrEK5NE1FeRWKVtvlZoHNVQVuVFP1xndvF8WEgDvg/116/image.jpg"
    },
    {
      "id": "custom_3ba14406-1720-41a6-af72-c763fb68ee3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-e5b1-72be-8283-459905c9eb88.webp",
      "image_media": {
        "alt_text": "Bedroom with a gray upholstered bed, two wooden nightstands, ceiling fan, and a window with white curtains.",
        "public_id": "019cfb42-e5b1-72be-8283-459905c9eb88",
        "storage_key": "property/6767906449165611/019cfb42-e5b1-72be-8283-459905c9eb88.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy primary bedroom in a modern apartment featuring neutral tones, natural light, and simple, stylish furnishings.",
      "link": "",
      "alt_text": "Bedroom with a gray upholstered bed, two wooden nightstands, ceiling fan, and a window with white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/GsWg-R6edS2IrRB9hpiMfEx5sPOD-ypjpEBaYsyDRwU/116/image.jpg"
    },
    {
      "id": "custom_3e66b27c-2b3d-4132-bc89-e1e56035088a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-e5b1-72be-8283-429087d3695a.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sofa, lit fireplace, coffee table, and large windows.",
        "public_id": "019cfb42-e5b1-72be-8283-429087d3695a",
        "storage_key": "property/6767906449165611/019cfb42-e5b1-72be-8283-429087d3695a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, inviting apartment living area with a gas fireplace, neutral décor, and comfortable seating.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sofa, lit fireplace, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sJdPpeVPekkmnd5pfYYdDWXBPF4HOArzXWs3yEinv44/116/image.jpg"
    },
    {
      "id": "custom_10b0d8bd-e438-4747-93bb-700db516a37b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-62dd-72fa-9291-aa7386c8a037.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sofa, fireplace, coffee table, and TV.",
        "public_id": "019d20af-62dd-72fa-9291-aa7386c8a037",
        "storage_key": "property/6767906449165611/019d20af-62dd-72fa-9291-aa7386c8a037.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy living room in a modern apartment featuring a fireplace, sofa, TV, and stylish decor.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sofa, fireplace, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/VhGpjyhdcwHAXuWOLVk7U5pJDOrmb-Ip11Nc36y6NRA/116/image.jpg"
    },
    {
      "id": "custom_78b6de05-96b7-46ed-a489-6d025a15c1e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-6522-758f-b15b-2ffb0afd5bd9.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel stove and microwave, and granite countertops.",
        "public_id": "019d20af-6522-758f-b15b-2ffb0afd5bd9",
        "storage_key": "property/6767906449165611/019d20af-6522-758f-b15b-2ffb0afd5bd9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with dark wood cabinets, stainless appliances, and granite countertops.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel stove and microwave, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jx8OEtmCG6EnjkdM6bd9IkLgYtxZlLn5OzZfWc8xtsQ/116/image.jpg"
    },
    {
      "id": "custom_f9243375-fcfe-4525-a01e-70e7e354225c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-6b24-77db-95c1-05681365a22c.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with a tub/shower, toilet, and dark wood vanity.",
        "public_id": "019d20af-6b24-77db-95c1-05681365a22c",
        "storage_key": "property/6767906449165611/019d20af-6b24-77db-95c1-05681365a22c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment bathroom featuring a tub/shower, granite countertop, and dark wood cabinetry.",
      "link": "",
      "alt_text": "Modern apartment bathroom with a tub/shower, toilet, and dark wood vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4d_diOg0Yph8pWJ5cKfz4BhQEH325VikAz2rmkjdddg/116/image.jpg"
    },
    {
      "id": "custom_40b3b2c1-1b44-4cfe-9261-8ec86237a6a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-6f63-74b8-87db-52c577dc32a7.webp",
      "image_media": {
        "alt_text": "Aerial city view with a church in the foreground and grid-like streets.",
        "public_id": "019d20af-6f63-74b8-87db-52c577dc32a7",
        "storage_key": "property/6767906449165611/019d20af-6f63-74b8-87db-52c577dc32a7.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Lifestyle",
      "description": "Bird's-eye view of a mid-sized city showing a main thoroughfare lined with buildings and a prominent church in the foreground.",
      "link": "",
      "alt_text": "Aerial city view with a church in the foreground and grid-like streets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165611/019cfb42-4830-720c-a7a9-94d53aa24c19.webp"
    },
    {
      "id": "custom_659fa6f1-6060-4105-901c-06d61836a93b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-7011-7492-879d-0d659b228fb0.webp",
      "image_media": {
        "alt_text": "Silhouette of a city skyline at sunset with an orange sky.",
        "public_id": "019d20af-7011-7492-879d-0d659b228fb0",
        "storage_key": "property/6767906449165611/019d20af-7011-7492-879d-0d659b228fb0.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Lifestyle",
      "description": "Sunset over a distant city skyline provides a warm, urban backdrop for the photo gallery.",
      "link": "",
      "alt_text": "Silhouette of a city skyline at sunset with an orange sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165611/019cfb42-482a-7098-8967-e22bb61e8a55.webp"
    },
    {
      "id": "custom_3b710460-6d16-46da-83a5-f57af2c4ef6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d20af-720b-7165-9970-4f7ec2d7ac62.webp",
      "image_media": {
        "alt_text": "Golden dragon statue atop rocks beside a waterway at dusk.",
        "public_id": "019d20af-720b-7165-9970-4f7ec2d7ac62",
        "storage_key": "property/6767906449165611/019d20af-720b-7165-9970-4f7ec2d7ac62.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "Exterior feature at the property: a striking golden dragon statue on rock by the water, offering a scenic focal point for residents.",
      "link": "",
      "alt_text": "Golden dragon statue atop rocks beside a waterway at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165611/019cfb42-4865-73ea-bbce-aaa2eef1f95b.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_262f515c-3b11-4ff1-9d16-712ba59bbe76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1109 E Interstate 240 Service Rd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "Texas Roadhouse-branded restaurant, known for its hand-cut steaks.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, including NY strip, sirloin, and prime rib, as well as fried pickles, green beans, and rolls. They also highlight the attentive staff, fast service, and fun atmosphere, especially for celebrations.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-3315-7065-9b03-43d2ce062ef4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3315-7065-9b03-43d2ce062ef4",
        "storage_key": "property/6767906449165611/019d2709-3315-7065-9b03-43d2ce062ef4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-south-i-240?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=13128196108413720888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.3922",
      "poi_longitude": "-97.4918158",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-631-8392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6657-7618-be9f-cc3c83dfeca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6657-7618-be9f-cc3c83dfeca6",
        "storage_key": "property/6767906449165611/019d2709-6657-7618-be9f-cc3c83dfeca6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_b1ObMVsocROFmq7824MLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_5226d4cd-b436-473c-8865-a044e15661d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Taste of China Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7435 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Buffet spot featuring Chinese staples, pizza and steaks.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of Chinese food, including Mongolian grill, sushi, and hibachi, as well as Mexican and Italian options. They also highlight the fresh food, attentive service, and great value for the price.\n\nSome reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-33aa-71c5-af20-49d6b2faeb4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-33aa-71c5-af20-49d6b2faeb4d",
        "storage_key": "property/6767906449165611/019d2709-33aa-71c5-af20-49d6b2faeb4d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tasteofchinarestaurant.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5294159430709800755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taste-of-china-restaurant",
      "poi_latitude": "35.3922925",
      "poi_longitude": "-97.5309638",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-631-1688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6657-7618-be9f-cc3c83dfeca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6657-7618-be9f-cc3c83dfeca6",
        "storage_key": "property/6767906449165611/019d2709-6657-7618-be9f-cc3c83dfeca6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXuPCIwTsocRM--92_OheEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_992fad27-ba3e-4ab2-bf58-d4245283a631",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2001 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Fast-food joint known for chicken sandwiches and waffle fries, and offering a kids' menu.",
      "poi_long_description": "People say this fast food restaurant serves chicken sandwiches and cob salads. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-34a6-73be-8c22-60aeac09be5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-34a6-73be-8c22-60aeac09be5a",
        "storage_key": "property/6767906449165611/019d2709-34a6-73be-8c22-60aeac09be5a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/moore?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304875027432141954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.3186309",
      "poi_longitude": "-97.4951348",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-799-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6657-7618-be9f-cc3c83dfeca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6657-7618-be9f-cc3c83dfeca6",
        "storage_key": "property/6767906449165611/019d2709-6657-7618-be9f-cc3c83dfeca6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8xCoDtrsocRgvRehuzYGxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_f998875d-e7e7-4c8c-ba35-1bbcf8d5c5e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "800 N Interstate Dr, Norman, OK 73072, USA",
      "poi_short_description": "Relaxed outpost dishing up homestyle American eats such as buttermilk pancakes, plus a gift shop.",
      "poi_long_description": "People say this restaurant serves delicious chicken and dumplings, chicken fried steak, and hashbrown casserole. They also highlight the friendly staff, the cozy atmosphere, and the unique shopping experience.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-3364-73f7-9308-88c67254e1ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3364-73f7-9308-88c67254e1ac",
        "storage_key": "property/6767906449165611/019d2709-3364-73f7-9308-88c67254e1ac.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ok/norman/181/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=12360073832655434620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "35.2284997",
      "poi_longitude": "-97.4867749",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-360-3117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6657-7618-be9f-cc3c83dfeca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6657-7618-be9f-cc3c83dfeca6",
        "storage_key": "property/6767906449165611/019d2709-6657-7618-be9f-cc3c83dfeca6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl6kFdnRpsocRfDMHEarNh6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ebec7c83-e439-4a9a-b191-f48932660cba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "World Fresh International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10700 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Produce and meat purveyor for Asian ingredients, baked goods and ethnic eats, plus tea.",
      "poi_long_description": "People say this grocery store offers a wide selection of international foods, fresh produce, and a variety of noodles and rice. They also highlight the delicious bakery, restaurants, and the availability of cookware and anime/K-pop merchandise.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-37ad-7654-b0a1-5d3fbdd329ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-37ad-7654-b0a1-5d3fbdd329ff",
        "storage_key": "property/6767906449165611/019d2709-37ad-7654-b0a1-5d3fbdd329ff.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.worldfreshmarketokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15266477169668212953&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "world-fresh-international-market",
      "poi_latitude": "35.3609259",
      "poi_longitude": "-97.5471485",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-349-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-665c-739b-860b-22518c65e2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-665c-739b-860b-22518c65e2d3",
        "storage_key": "property/6767906449165611/019d2709-665c-739b-860b-22518c65e2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVfSKFoTsocR2UivvRls3dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_63c8aaa0-3c60-4c5d-9604-2b6503aeb2cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12100 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Grocery store featuring fresh produce and organic options, plus bins of spices, nuts and sweets.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce, delicious breads, and high-quality meats. They highlight the store is clean, well-organized, and stocks items not found elsewhere, including gluten-free and vegan options. They also like the friendly, helpful, and informative staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-3806-757f-911e-d7127d241251.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3806-757f-911e-d7127d241251",
        "storage_key": "property/6767906449165611/019d2709-3806-757f-911e-d7127d241251.webp",
        "width": 640,
        "height": 511
      },
      "poi_business_url": "https://www.sprouts.com/store/ok/moore/moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=463326420679037265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.3469891",
      "poi_longitude": "-97.5466047",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-416-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-665c-739b-860b-22518c65e2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-665c-739b-860b-22518c65e2d3",
        "storage_key": "property/6767906449165611/019d2709-665c-739b-860b-22518c65e2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9YBcOkTsocRUZGgv-wQbgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_27715918-069a-4c49-9054-93d6ea10e149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10601 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Chain grocery outlet supplying produce, baked goods, and sushi, plus self-checkout.",
      "poi_long_description": "People say this grocery store offers fresh produce, a wide selection of items, and a deli department that slices meat and cheese to order. They highlight the competitive prices, good sales, and well-stocked shelves. They also like the clean and spacious layout, and the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-3821-74e0-a912-687340c5b0a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3821-74e0-a912-687340c5b0a5",
        "storage_key": "property/6767906449165611/019d2709-3821-74e0-a912-687340c5b0a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4018949886565178595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.3622151",
      "poi_longitude": "-97.5680332",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-814-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-665c-739b-860b-22518c65e2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-665c-739b-860b-22518c65e2d3",
        "storage_key": "property/6767906449165611/019d2709-665c-739b-860b-22518c65e2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwfJhuAITsocR41zQ5qAtxjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_96c68639-d2f7-4d11-a7a2-060d169df616",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2555 Hemphill Dr, Norman, OK 73069, USA",
      "poi_short_description": "Chain supplying home-improvement materials, appliances, paint, and patio furniture, plus lawn-equipment rental.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products. They also highlight the helpful staff and quick and easy pick-up service.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-38eb-70e5-aedc-7f520769da89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-38eb-70e5-aedc-7f520769da89",
        "storage_key": "property/6767906449165611/019d2709-38eb-70e5-aedc-7f520769da89.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Norman/1165?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1165-_-na-_-0-_-0&y_source=1_MTE4MzI1MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16039383829879335227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.224972",
      "poi_longitude": "-97.481412",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-329-2009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6659-722b-9809-f81bfc5f4525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6659-722b-9809-f81bfc5f4525",
        "storage_key": "property/6767906449165611/019d2709-6659-722b-9809-f81bfc5f4525.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi62bmwppsocROyka7JxWl94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_097c5e3d-3572-43ad-8663-6b64a9512c17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7400 S Shields Blvd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "Popular home improvement chain featuring tools, appliances, building materials and garden equipment.",
      "poi_long_description": "People say this home improvement store is well-stocked and the staff are helpful, friendly, and eager to guide customers to the products they need. They also highlight the great customer service and good deals and promotions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-3bef-71cc-b9d0-421b3e853535.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3bef-71cc-b9d0-421b3e853535",
        "storage_key": "property/6767906449165611/019d2709-3bef-71cc-b9d0-421b3e853535.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/S-Oklahoma-City/OK/Oklahoma-City/73149/3901?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9319995899506957809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.3933171",
      "poi_longitude": "-97.5048175",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-631-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6659-722b-9809-f81bfc5f4525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6659-722b-9809-f81bfc5f4525",
        "storage_key": "property/6767906449165611/019d2709-6659-722b-9809-f81bfc5f4525.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZZnC3msUsocR8Z01IuRGV4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_d2aaea1f-f06f-487d-84f5-7ee05f4b67e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Mid-America Christian University",
      "poi_type": "Education",
      "poi_address": "3500 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-3ce9-74cc-8009-b5beab78d2f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3ce9-74cc-8009-b5beab78d2f5",
        "storage_key": "property/6767906449165611/019d2709-3ce9-74cc-8009-b5beab78d2f5.webp",
        "width": 1280,
        "height": 453
      },
      "poi_business_url": "https://www.macu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1537180270262459685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mid-america-christian-university",
      "poi_latitude": "35.3477803",
      "poi_longitude": "-97.5784864",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-691-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6679-76de-8957-1bbc8303010e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6679-76de-8957-1bbc8303010e",
        "storage_key": "property/6767906449165611/019d2709-6679-76de-8957-1bbc8303010e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIw1jLcMSsocRJZ27vE8pVRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0baf0897-6eb2-4ce3-8142-46ffe2750ef0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Pioneer Library System - Moore Public Library",
      "poi_type": "Education",
      "poi_address": "225 S Howard Ave, Moore, OK 73160, USA",
      "poi_short_description": "Local institution that provides books, DVDs, computers and programs, with an emphasis on children's offerings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-3db5-7244-ba6c-88e2ae7faceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3db5-7244-ba6c-88e2ae7faceb",
        "storage_key": "property/6767906449165611/019d2709-3db5-7244-ba6c-88e2ae7faceb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pioneerlibrarysystem.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13566280005030728682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---moore-public-library",
      "poi_latitude": "35.3358205",
      "poi_longitude": "-97.4885841",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-793-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6a2f-732f-bbd1-8313803e8c9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6a2f-732f-bbd1-8313803e8c9f",
        "storage_key": "property/6767906449165611/019d2709-6a2f-732f-bbd1-8313803e8c9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xg3BdMUsocR6lNXj8kbRbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b2d189dc-49ec-4036-80b2-3c03054a1d42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Randall University",
      "poi_type": "Education",
      "poi_address": "3701 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-3cf7-71db-ac3f-0a145b9e6a13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3cf7-71db-ac3f-0a145b9e6a13",
        "storage_key": "property/6767906449165611/019d2709-3cf7-71db-ac3f-0a145b9e6a13.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1911580702336403596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "randall-university",
      "poi_latitude": "35.300769",
      "poi_longitude": "-97.491047",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-912-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6679-76de-8957-1bbc8303010e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6679-76de-8957-1bbc8303010e",
        "storage_key": "property/6767906449165611/019d2709-6679-76de-8957-1bbc8303010e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7VS3UoQWsocRjMhAUoVMhxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0a909bd1-0abe-497a-a593-520dae8c649f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Southern Oaks Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "6900 S Walker Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Library with helpful staff and computer-help services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-40c6-7169-9879-b1c2c844ed4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-40c6-7169-9879-b1c2c844ed4f",
        "storage_key": "property/6767906449165611/019d2709-40c6-7169-9879-b1c2c844ed4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11815021574882502459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-oaks-library---metropolitan-library-system",
      "poi_latitude": "35.397253",
      "poi_longitude": "-97.520442",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-631-4468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6679-76de-8957-1bbc8303010e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6679-76de-8957-1bbc8303010e",
        "storage_key": "property/6767906449165611/019d2709-6679-76de-8957-1bbc8303010e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy7O6kNITsocRO6dyEIZj96M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_3ee941af-543a-4147-9bab-b3f3ce467733",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Pioneer Library System - Southwest Oklahoma City Public Library",
      "poi_type": "Education",
      "poi_address": "2201 SW 134th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Family-friendly public library offering reading materials, computers, and meeting spaces.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-412c-7164-96d6-8b5907e13259.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-412c-7164-96d6-8b5907e13259",
        "storage_key": "property/6767906449165611/019d2709-412c-7164-96d6-8b5907e13259.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://pioneerlibrarysystem.org/sokc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3987797506462036039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---southwest-oklahoma-city-public-library",
      "poi_latitude": "35.3346851",
      "poi_longitude": "-97.549823",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-979-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6a2f-732f-bbd1-8313803e8c9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6a2f-732f-bbd1-8313803e8c9f",
        "storage_key": "property/6767906449165611/019d2709-6a2f-732f-bbd1-8313803e8c9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zBOjQTsocRR7DbMLSAVzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7a7e5ce0-483d-4d34-9b0d-c8b274129781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Museum of Osteology",
      "poi_type": "Entertainment",
      "poi_address": "10301 S Sunnylane Rd, Oklahoma City, OK 73160, USA",
      "poi_short_description": "Bone museum showcasing hundreds of skulls and skeletons from all corners of the world.",
      "poi_long_description": "People say this museum offers a vast collection of animal skeletons, skulls, and taxidermy, with educational displays and scavenger hunts for all ages. They highlight the fun and immersive experience, especially during Forensic Night, and the informative and engaging atmosphere. They also like the friendly and knowledgeable staff, and the amazing gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-42ed-7372-8872-9d26a05d3fa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-42ed-7372-8872-9d26a05d3fa0",
        "storage_key": "property/6767906449165611/019d2709-42ed-7372-8872-9d26a05d3fa0.webp",
        "width": 1209,
        "height": 907
      },
      "poi_business_url": "http://www.skeletonmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091622308725140297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-osteology",
      "poi_latitude": "35.3648349",
      "poi_longitude": "-97.4418414",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-814-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6a71-7268-8309-1833649733d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6a71-7268-8309-1833649733d7",
        "storage_key": "property/6767906449165611/019d2709-6a71-7268-8309-1833649733d7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57ahxGMVsocRSSuU_1HuK34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2d0203dc-640a-4d1e-824f-26ee75c170c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2800 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Trampoline park and adventure center featuring go-karts, ropes courses and party rooms.",
      "poi_long_description": "People say this amusement park offers a wide variety of attractions, including go-karts, trampolines, and a ball pit, and is a fun place for birthday parties.\n\nOther reviews mention the go-karts can be slow and the dodgeball area can be unsupervised.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4394-7529-b222-8fa61e66d700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4394-7529-b222-8fa61e66d700",
        "storage_key": "property/6767906449165611/019d2709-4394-7529-b222-8fa61e66d700.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-moore/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=454199799262834417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.3130452",
      "poi_longitude": "-97.4932574",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-655-5805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcSyRgFtrsocR8W4dnE-kTQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1873d81d-47e6-40a1-8561-e4534f045d2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Westwood Family Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "1017 Fairway Dr, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this water park offers a lazy river, slides, and pools for different age groups, including a kiddie play pool and toddler pool. They highlight the clean environment, reasonable prices, and fun atmosphere for the whole family. They also like the attentive lifeguards and staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-45bc-72ce-a481-a615718ff322.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-45bc-72ce-a481-a615718ff322",
        "storage_key": "property/6767906449165611/019d2709-45bc-72ce-a481-a615718ff322.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/westwood-family-aquatic-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3451467788169588585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westwood-family-aquatic-center",
      "poi_latitude": "35.2306896",
      "poi_longitude": "-97.4778914",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-447-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZQom55psocRaS-Nq6oT5i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_4067f77e-49a0-4a83-b25b-038f3d781355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "National Weather Museum and Science Center",
      "poi_type": "Entertainment",
      "poi_address": "1200 W Rock Creek Rd, Norman, OK 73071, USA",
      "poi_short_description": "Informative exhibit on the history of weather instruments and sciences, plus interactive kids’ areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4628-721a-a0ec-e46447e8df72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4628-721a-a0ec-e46447e8df72",
        "storage_key": "property/6767906449165611/019d2709-4628-721a-a0ec-e46447e8df72.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://nationalweathermuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7002409609566509002&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "national-weather-museum-and-science-center",
      "poi_latitude": "35.246768",
      "poi_longitude": "-97.4573701",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-651-8649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6a71-7268-8309-1833649733d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6a71-7268-8309-1833649733d7",
        "storage_key": "property/6767906449165611/019d2709-6a71-7268-8309-1833649733d7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7K_DPVpsocRylf-hXCOLWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fe4b2c74-0d64-49bc-99d7-786a6484a9ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Moore Schools Stadium",
      "poi_type": "Entertainment",
      "poi_address": "911 E Main St, Moore, OK 73160, USA",
      "poi_short_description": "High school and semiprofessional football stadium with a track.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4811-72bc-9d47-82fb9003da01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4811-72bc-9d47-82fb9003da01",
        "storage_key": "property/6767906449165611/019d2709-4811-72bc-9d47-82fb9003da01.webp",
        "width": 1233,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10911573051037220494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moore-schools-stadium",
      "poi_latitude": "35.3390384",
      "poi_longitude": "-97.4730242",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6a9d-76e8-9bb9-6925f85bd81a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6a9d-76e8-9bb9-6925f85bd81a",
        "storage_key": "property/6767906449165611/019d2709-6a9d-76e8-9bb9-6925f85bd81a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsSD0iyYVsocRjn7Mv-CxbZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_355d8ff2-52fe-4551-84f0-e07a81731345",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Earlywine Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "11801 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Vast gym & fitness center featuring an indoor swimming pool, a kids' play area, and a walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4818-723a-8229-1c8e48ffb73b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4818-723a-8229-1c8e48ffb73b",
        "storage_key": "property/6767906449165611/019d2709-4818-723a-8229-1c8e48ffb73b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/earlywine-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3511656398763592292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "earlywine-park-ymca",
      "poi_latitude": "35.349746",
      "poi_longitude": "-97.566403",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-378-0420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7zS1CETsocRZAqInePouzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2a73221f-195f-4565-b8e8-de1eec259396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Four Star Fitness - Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "1219 N Santa Fe Ave, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center has a great daycare with friendly staff who genuinely like children, and they appreciate the variety of equipment and 24-hour access. They also highlight the welcoming and inclusive atmosphere, with staff who are always smiling and helpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4ab6-7782-a6ee-a0026b0ce225.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4ab6-7782-a6ee-a0026b0ce225",
        "storage_key": "property/6767906449165611/019d2709-4ab6-7782-a6ee-a0026b0ce225.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fourstarfitnessokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11507987364897746889&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---moore",
      "poi_latitude": "35.348233",
      "poi_longitude": "-97.5138619",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-237-3740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4hkozQVsocRye9pVImVtJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_46ae3d63-8d91-47cb-bc4d-1a8993526d02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9118 S Western Ave A, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Bustling national chain gym with standard workout equipment, massage beds and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and a Black Card area with massage chairs and hydro massage. They highlight the clean, well-lit, and organized facility, and the comfortable, judgment-free atmosphere. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4a58-7689-84e2-7bbac40e2064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4a58-7689-84e2-7bbac40e2064",
        "storage_key": "property/6767906449165611/019d2709-4a58-7689-84e2-7bbac40e2064.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-brookwood-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7943029326332511845&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.3762027",
      "poi_longitude": "-97.5281104",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-237-3709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQsn6IETsocRZUaPnBZPO24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5b4fcd0a-5d5c-4bc2-b566-eacae947763e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Norman Regional The Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 36th Ave NW, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4d2a-7292-9254-e4bb10896ea2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4d2a-7292-9254-e4bb10896ea2",
        "storage_key": "property/6767906449165611/019d2709-4d2a-7292-9254-e4bb10896ea2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanregional.com/the-health-club/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6654177676307732909&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-the-health-club",
      "poi_latitude": "35.246075",
      "poi_longitude": "-97.4938832",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-329-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY3tEmZNpsocRrRmoXFdjWFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_53f94ed4-9311-4b00-a929-7e2df41377bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 SW 104th St, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Gym chain offering strength and cardio equipment, as well as tanning and saunas.",
      "poi_long_description": "People say this gym offers a wide variety of modern equipment, including free weights, machines, and cardio options, and has amenities like massage chairs, a sauna, and tanning. They highlight the affordable prices, convenient 24-hour access, and clean facilities. They also like the friendly, helpful, and supportive staff, and the motivating and welcoming environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4cc7-70ed-92ea-41b228fafe1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4cc7-70ed-92ea-41b228fafe1b",
        "storage_key": "property/6767906449165611/019d2709-4cc7-70ed-92ea-41b228fafe1b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://10gym.com/so-oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4025751960966699643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "35.3623584",
      "poi_longitude": "-97.5337511",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-691-0037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3Vq12QTsocRe5pAQxRY3jc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8f494f50-7b91-4c73-9eb8-3d6ec106f0cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "790 SW 19th St Ste B, Moore, OK 73160, USA",
      "poi_short_description": "Beauty shop selling over 500 brands of cosmetics plus hair and skin-care products.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-4f0c-709d-b904-0e245ca8ccec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4f0c-709d-b904-0e245ca8ccec",
        "storage_key": "property/6767906449165611/019d2709-4f0c-709d-b904-0e245ca8ccec.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/moore-ok-1548",
      "poi_directions_map_url": "https://maps.google.com/?cid=15419934176653925947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.3177824",
      "poi_longitude": "-97.5024523",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-977-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-jf2HlrsocRO95cc2-c_tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_88e4b382-20f1-4316-b543-f958b0276ad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Barbershop Fade Fathers",
      "poi_type": "Health and Wellness",
      "poi_address": "8013 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Barber shop in the 240 Plaza Shopping Center offering professional haircuts and beard trims.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-502f-71b4-8b87-f92e2f7e68fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-502f-71b4-8b87-f92e2f7e68fc",
        "storage_key": "property/6767906449165611/019d2709-502f-71b4-8b87-f92e2f7e68fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fadefathers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12362820288136197204&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barbershop-fade-fathers",
      "poi_latitude": "35.3863046",
      "poi_longitude": "-97.5304614",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-764-3767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBy3H87MTsocRVLRZEI2Pkas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_cf2927c5-ceae-4429-b55b-254840ef6c00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Animal Emergency & Surgical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "931 W I-240 Service Road, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-51fc-74bc-afdd-61ef9419277a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-51fc-74bc-afdd-61ef9419277a",
        "storage_key": "property/6767906449165611/019d2709-51fc-74bc-afdd-61ef9419277a.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.okcanimalemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3482013980382145679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency--surgical-center",
      "poi_latitude": "35.3919712",
      "poi_longitude": "-97.531539",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-631-7828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36JJPYwTsocRjyyfQ0SZUjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_76a32960-f7f2-4cf3-862a-59c925140a40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Filed Nails Spa Beauty, Norman, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "3408 36th Ave NW STE 116, Norman, OK 73072, USA",
      "poi_short_description": "Casual nail salon offering manis-pedis, plus acrylics & customized nail art.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-5172-71d5-a45a-91c6e6a49bbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5172-71d5-a45a-91c6e6a49bbc",
        "storage_key": "property/6767906449165611/019d2709-5172-71d5-a45a-91c6e6a49bbc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.filednailspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7696990407116716923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "filed-nails-spa-beauty-norman-ok",
      "poi_latitude": "35.2587242",
      "poi_longitude": "-97.4947891",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-801-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtXLsUUdrsocRe_vHr_4z0Wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_fbed7f04-ed75-4180-a179-002f3977cac1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Norman Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Healthplex Pkwy, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-54d7-706a-af15-0801bcf4c5c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-54d7-706a-af15-0801bcf4c5c1",
        "storage_key": "property/6767906449165611/019d2709-54d7-706a-af15-0801bcf4c5c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.normanregional.com/locations/norman-regional-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5166678913039723209&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-hospital",
      "poi_latitude": "35.2599491",
      "poi_longitude": "-97.4885857",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-515-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6e7d-705c-86f7-9604e7a64462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6e7d-705c-86f7-9604e7a64462",
        "storage_key": "property/6767906449165611/019d2709-6e7d-705c-86f7-9604e7a64462.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp8UVz89rsocRyeo74Bi7s0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1fb755b5-b052-4b28-bf9b-a8b0fd15a5bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Norman Regional Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "700 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-54d0-7293-847a-2b6222677de8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-54d0-7293-847a-2b6222677de8",
        "storage_key": "property/6767906449165611/019d2709-54d0-7293-847a-2b6222677de8.webp",
        "width": 1280,
        "height": 785
      },
      "poi_business_url": "https://www.normanregional.com/locations/norman-regional-moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6671442604466481346&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-moore",
      "poi_latitude": "35.3325506",
      "poi_longitude": "-97.4932073",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-793-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6e7d-705c-86f7-9604e7a64462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6e7d-705c-86f7-9604e7a64462",
        "storage_key": "property/6767906449165611/019d2709-6e7d-705c-86f7-9604e7a64462.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdxkYvjJrsocRwqihsrO5lVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_612c559c-8530-4abf-852a-7e459a7f6b42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Buck Thomas Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1903 NE 12th St, Moore, OK 73160, USA",
      "poi_short_description": "Outdoor space for sports and picnics featuring baseball fields and a playground.",
      "poi_long_description": "Expansive, nearly 130-acre park featuring a playground, fishing, a walking trail & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-5614-71bc-89b1-fb3ea443d96f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5614-71bc-89b1-fb3ea443d96f",
        "storage_key": "property/6767906449165611/019d2709-5614-71bc-89b1-fb3ea443d96f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/buck-thomas-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701592146103086508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buck-thomas-park",
      "poi_latitude": "35.3524633",
      "poi_longitude": "-97.4668896",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6e1f-740f-94c3-f13c6cb94bc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6e1f-740f-94c3-f13c6cb94bc8",
        "storage_key": "property/6767906449165611/019d2709-6e1f-740f-94c3-f13c6cb94bc8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB31aBTwVsocRrK3BdXbVJb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5ec13f36-a8f3-4318-8965-5dfe6f56f9a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Little River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "709 SW 10th St, Moore, OK 73160, USA",
      "poi_short_description": "Family-friendly park with a splash park, a playground and a pirate ship.",
      "poi_long_description": "People say this park offers a fun splash pad with water slides, a playground, and walking trails. They highlight the free admission and the mini water park experience. They also like the plentiful seating and the fenced splash pad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-565e-75fd-ac93-dba94e426aa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-565e-75fd-ac93-dba94e426aa5",
        "storage_key": "property/6767906449165611/019d2709-565e-75fd-ac93-dba94e426aa5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/little-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13309531068765424630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "little-river-park",
      "poi_latitude": "35.3275656",
      "poi_longitude": "-97.50192",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6e1f-740f-94c3-f13c6cb94bc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6e1f-740f-94c3-f13c6cb94bc8",
        "storage_key": "property/6767906449165611/019d2709-6e1f-740f-94c3-f13c6cb94bc8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cPHdTZrsocR9svJeP3ztLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_967d0c02-206b-4234-b6c8-a37cde8fe358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Earlywine Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11600 S Portland Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this golf course offers two great courses and a new clubhouse. They also highlight the affordable food, easy parking, and helpful staff.\n\nOther reviews mention the course conditions can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-5b10-75a0-9d76-ba9ae6421a5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5b10-75a0-9d76-ba9ae6421a5e",
        "storage_key": "property/6767906449165611/019d2709-5b10-75a0-9d76-ba9ae6421a5e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okcgolf.com/earlywine-golf-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=12680274809197614446&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "earlywine-golf-course",
      "poi_latitude": "35.3519648",
      "poi_longitude": "-97.5817358",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-691-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6ee8-720e-9198-1440692afaf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6ee8-720e-9198-1440692afaf3",
        "storage_key": "property/6767906449165611/019d2709-6ee8-720e-9198-1440692afaf3.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJj3nZU-4SsocRbtWOiMFi-a8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_aa53bf74-dfdb-44f6-821d-016276bdbe9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Sutton Wilderness Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1920 12th Ave NE, Norman, OK 73071, USA",
      "poi_short_description": "Dog-friendly outdoor lake loop featuring flat trails and wooded areas for walking, jogging and biking.",
      "poi_long_description": "People say this park offers trails for walking, jogging, and biking, as well as fishing and nature exploration. They highlight the peaceful and relaxing atmosphere, and the beautiful scenery with a pond and plenty of shade. They also like that it's pet-friendly and suitable for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-5b62-73c6-acd0-38a34800a349.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5b62-73c6-acd0-38a34800a349",
        "storage_key": "property/6767906449165611/019d2709-5b62-73c6-acd0-38a34800a349.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/george-m-sutton-wilderness-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1152383032856291791&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutton-wilderness-trail-park",
      "poi_latitude": "35.24229710000001",
      "poi_longitude": "-97.4238198",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6e1f-740f-94c3-f13c6cb94bc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6e1f-740f-94c3-f13c6cb94bc8",
        "storage_key": "property/6767906449165611/019d2709-6e1f-740f-94c3-f13c6cb94bc8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYvmTBpCsocRzymWRkMW_g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b167cb02-b9fb-4f8f-8589-e9b708eb7a1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Ruby Grant Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3110 W Franklin Rd, Norman, OK 73072, USA",
      "poi_short_description": "Park featuring play areas, barbecue grills and disc golf, along with hiking and walking trails.",
      "poi_long_description": "People say this park offers a fun walk and a disc golf course. They highlight the well-maintained area and the full sun exposure. They also like the proximity to a dog park. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-5ab0-726c-8027-97067e70cd87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5ab0-726c-8027-97067e70cd87",
        "storage_key": "property/6767906449165611/019d2709-5ab0-726c-8027-97067e70cd87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/ruby-grant-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=69868048196119437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ruby-grant-park",
      "poi_latitude": "35.2756272",
      "poi_longitude": "-97.489092",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6e1f-740f-94c3-f13c6cb94bc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6e1f-740f-94c3-f13c6cb94bc8",
        "storage_key": "property/6767906449165611/019d2709-6e1f-740f-94c3-f13c6cb94bc8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYZIsdtrsocRjSvhoZ44-AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a703fa2e-2a98-48ec-8b52-ed1095c52aed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Max Westheimer Airport KOUN",
      "poi_type": "Transportation & Transit",
      "poi_address": "1700 Lexington Ave #109, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-5cb4-718c-b8e1-ffa3fa724018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5cb4-718c-b8e1-ffa3fa724018",
        "storage_key": "property/6767906449165611/019d2709-5cb4-718c-b8e1-ffa3fa724018.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://airport.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12939952151657294093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "max-westheimer-airport-koun",
      "poi_latitude": "35.2409761",
      "poi_longitude": "-97.4680511",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-325-7233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6eb6-75ef-86ca-e89d5157ac22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6eb6-75ef-86ca-e89d5157ac22",
        "storage_key": "property/6767906449165611/019d2709-6eb6-75ef-86ca-e89d5157ac22.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9TluYdpsocRDakVUuzxk7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0ccc54b3-1dcd-49fa-9c1d-ebe4a7027691",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Simple Modern Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "750 SW 24th St Suite 300, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-5f76-72dd-93f1-80580f6cad77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5f76-72dd-93f1-80580f6cad77",
        "storage_key": "property/6767906449165611/019d2709-5f76-72dd-93f1-80580f6cad77.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "http://simplemodern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364504164759517206&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "simple-modern-headquarters",
      "poi_latitude": "35.3164404",
      "poi_longitude": "-97.5021957",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfe83ix9rsocRFjiYkB2Mcko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dac7d46d-a52f-4873-bd7a-98dc2a7f9b45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Integrated Power Services (IPS) - Norman",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6707 N Interstate Dr, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-60b2-732a-aba3-f778777149ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-60b2-732a-aba3-f778777149ae",
        "storage_key": "property/6767906449165611/019d2709-60b2-732a-aba3-f778777149ae.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://ips.us/location/evans-norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2485684183795281028&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integrated-power-services-ips---norman",
      "poi_latitude": "35.2991008",
      "poi_longitude": "-97.4888055",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-631-1344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqenS6wRrsocRhKzsbpjsfiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_839f6fc3-bb8b-4981-a68f-e453d8ff5b68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "WFEC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3000 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-61cd-7358-b825-b1981ccae905.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-61cd-7358-b825-b1981ccae905",
        "storage_key": "property/6767906449165611/019d2709-61cd-7358-b825-b1981ccae905.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wfec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11816483374180755416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wfec",
      "poi_latitude": "35.31055600000001",
      "poi_longitude": "-97.4938519",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-759-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-U_1KhZrsocR2GdavAWV_KM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d7c2ac47-d247-476e-9a50-83ff12ea5e42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Trans-Tel Central, LLC Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2851 N Flood Ave, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://trans-tel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966786705039048130&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trans-tel-central-llc-corporate-office",
      "poi_latitude": "35.2534979",
      "poi_longitude": "-97.4657052",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-447-5025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWsrK9drsocRwj2MCgBtcHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_910368cd-3600-45c4-ab18-a09bcab96bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "USPS Maintenance Technical Support Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 W Rock Creek Rd, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.usps.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3537584333909126976&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "usps-maintenance-technical-support-center",
      "poi_latitude": "35.2465782",
      "poi_longitude": "-97.4511871",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-366-1663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-6aae-741c-aaa3-68c927833739",
        "storage_key": "property/6767906449165611/019d2709-6aae-741c-aaa3-68c927833739.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw09rHvdpsocRQO-jcTUGGDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_52cd9d4c-88f7-4585-91c7-fa19aa8fd062",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Oakridge Elementary School",
      "poi_type": "Education",
      "poi_address": "3201 S Santa Fe Ave, Moore, OK 73160, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-a055-7617-a6de-af417ddbaab1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a055-7617-a6de-af417ddbaab1",
        "storage_key": "property/6767906449165611/019d7912-a055-7617-a6de-af417ddbaab1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oakridge.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6080449283468928576&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oakridge-elementary-school",
      "poi_latitude": "35.306801",
      "poi_longitude": "-97.5130179",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-735-4530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952e-70e9-babf-3f65656d5260",
        "storage_key": "property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJde9VvGhrsocRQKbxX2gYYlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_504a2526-723e-4c51-8b77-79a9bec57066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Briarwood Elementary School",
      "poi_type": "Education",
      "poi_address": "14901 S Hudson Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-9f71-72b6-8bfb-2998e2ec1fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9f71-72b6-8bfb-2998e2ec1fdc",
        "storage_key": "property/6767906449165611/019d7912-9f71-72b6-8bfb-2998e2ec1fdc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://briarwood.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2029875763870875059&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "briarwood-elementary-school",
      "poi_latitude": "35.3210061",
      "poi_longitude": "-97.5202569",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-735-4110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952e-70e9-babf-3f65656d5260",
        "storage_key": "property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAb7J-VlrsocRs72yo0CRKxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_aed94880-8a94-4354-aca0-1be649aecb71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Broadmoore Elementary School",
      "poi_type": "Education",
      "poi_address": "3401 S Broadway Ave, Moore, OK 73160, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-9fc8-7751-8065-32ed1108de1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9fc8-7751-8065-32ed1108de1a",
        "storage_key": "property/6767906449165611/019d7912-9fc8-7751-8065-32ed1108de1a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://broadmoore.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9788492299944842408&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broadmoore-elementary-school",
      "poi_latitude": "35.3061686",
      "poi_longitude": "-97.4709805",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-735-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952e-70e9-babf-3f65656d5260",
        "storage_key": "property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGV1saO9qsocRqNTbmOK114c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ed1d0b45-50a9-4892-a155-53dfed88b7d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Highland East Junior High School",
      "poi_type": "Education",
      "poi_address": "1200 SE 4th St, Moore, OK 73160, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://highlandeastjh.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9428477188982400911&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highland-east-junior-high-school",
      "poi_latitude": "35.3334453",
      "poi_longitude": "-97.4688591",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-735-4580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952e-70e9-babf-3f65656d5260",
        "storage_key": "property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAeXiAQZrsocRj2crlgyu2II",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_56c5ce8e-66d2-4c62-943f-ca6397d1f1b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Central Junior High School",
      "poi_type": "Education",
      "poi_address": "400 N Broadway Ave, Moore, OK 73160, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-a017-72ed-ac29-b9c9ed973760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a017-72ed-ac29-b9c9ed973760",
        "storage_key": "property/6767906449165611/019d7912-a017-72ed-ac29-b9c9ed973760.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mooreschools.com/Domain/1328",
      "poi_directions_map_url": "https://maps.google.com/?cid=5888238045095944931&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-junior-high-school",
      "poi_latitude": "35.3423385",
      "poi_longitude": "-97.4872665",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-735-4560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952e-70e9-babf-3f65656d5260",
        "storage_key": "property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbUReMC4VsocR42LiBk45t1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_aa50e030-1828-45b3-bd2e-77f6ee52b5c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Oklahoma School of Science and Mathematics",
      "poi_type": "Education",
      "poi_address": "1141 N Lincoln Blvd, Oklahoma City, OK 73104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-aa38-7519-804e-00302e0830eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-aa38-7519-804e-00302e0830eb",
        "storage_key": "property/6767906449165611/019d7912-aa38-7519-804e-00302e0830eb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ossm.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6798167282039383181&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-school-of-science-and-mathematics",
      "poi_latitude": "35.4786644",
      "poi_longitude": "-97.5057992",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-521-6436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952e-70e9-babf-3f65656d5260",
        "storage_key": "property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8XHl0D0XsocRjeSj8R_xV14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_df630704-31fc-4e22-8448-ed445c951467",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Dove Science Academy Middle/High School South OKC",
      "poi_type": "Education",
      "poi_address": "1211 E Interstate 240 Service Rd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-a92d-766e-b673-2e2e209bb2d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a92d-766e-b673-2e2e209bb2d6",
        "storage_key": "property/6767906449165611/019d7912-a92d-766e-b673-2e2e209bb2d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://dsamssouthokc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=62070290895091722&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dove-science-academy-middle-high-school-south-okc",
      "poi_latitude": "35.3931161",
      "poi_longitude": "-97.4901549",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-724-8966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952e-70e9-babf-3f65656d5260",
        "storage_key": "property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuzm2seQVsocRCjjox5mE3AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8fdbc4e5-aa2a-4d90-847d-27ada846567f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Westmoore High School",
      "poi_type": "Education",
      "poi_address": "12613 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-a978-72fe-a381-99961ad6e058.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a978-72fe-a381-99961ad6e058",
        "storage_key": "property/6767906449165611/019d7912-a978-72fe-a381-99961ad6e058.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://westmoorehs.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9023050078341389623&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "westmoore-high-school",
      "poi_latitude": "35.3424114",
      "poi_longitude": "-97.5342346",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-735-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952e-70e9-babf-3f65656d5260",
        "storage_key": "property/6767906449165611/019cfb42-952e-70e9-babf-3f65656d5260.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvaTAo1oTsocRN10Zdj1QOH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_140b129b-46ad-4555-a8b1-4d47166aa309",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Zaxbys Chicken Fingers & Buffalo Wings",
      "poi_type": "Restaurants",
      "poi_address": "2720 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "Chain eatery serving up fried chicken fingers, wings, sandwiches & other American comfort food.",
      "poi_long_description": "People say this chicken restaurant serves tasty chicken fingers, fries, and coleslaw. They also highlight the friendly people and good value, especially during happy hour.\n\nSome reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-aca2-75cf-9b43-742be294803d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-aca2-75cf-9b43-742be294803d",
        "storage_key": "property/6767906449165611/019d7912-aca2-75cf-9b43-742be294803d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.zaxbys.com/locations/ok/moore/2720-s-service-rd?utm_source=extnet&utm_medium=organic&utm_campaign=local-listings&utm_content=56201",
      "poi_directions_map_url": "https://maps.google.com/?cid=16074698372688947371&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "zaxbys-chicken-fingers-buffalo-wings",
      "poi_latitude": "35.313788",
      "poi_longitude": "-97.4889642",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-703-2186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952c-73da-81cf-181f39380d49",
        "storage_key": "property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg4NTZiJrsocRq6ispwDNFN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_172bf675-dcd3-4742-8303-17b41734cf29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "2401 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "People say this restaurant serves delicious food, including ribs, steaks, and wonton tacos.\n\nOther reviews mention the service can be slow and the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-b3eb-7513-9985-60b7b30e9fea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b3eb-7513-9985-60b7b30e9fea",
        "storage_key": "property/6767906449165611/019d7912-b3eb-7513-9985-60b7b30e9fea.webp",
        "width": 1024,
        "height": 650
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/ok/moore/2401-s-i-35-service-rd-97047?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=97047&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=17855304064412750586&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "applebee-s-grill-bar",
      "poi_latitude": "35.3160488",
      "poi_longitude": "-97.4911593",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-378-4375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952c-73da-81cf-181f39380d49",
        "storage_key": "property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ161QCNrsocR-hLp83HIyvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_58d8c6c5-2761-4546-b5f9-b8c4a34dcc85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Volcano Sushi Bar & Hibachi",
      "poi_type": "Restaurants",
      "poi_address": "2727 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "ContemporaryJapanese eatery offering grilled-to-order meat entrees, noodles, sushi & lunch specials.",
      "poi_long_description": "People say this sushi restaurant offers delicious bento boxes, sushi rolls, and grilled squid. They highlight the reasonable prices, especially for lunch specials and Tuesday buy-one-get-one-half-price sushi rolls. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-b53a-71a4-88ed-587d6d02a308.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b53a-71a4-88ed-587d6d02a308",
        "storage_key": "property/6767906449165611/019d7912-b53a-71a4-88ed-587d6d02a308.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://volcanook.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6569068175266778509&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "volcano-sushi-bar-hibachi",
      "poi_latitude": "35.311745",
      "poi_longitude": "-97.491141",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-759-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952c-73da-81cf-181f39380d49",
        "storage_key": "property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdZtHfQUsocRjY0ZdLMEKls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_36c14cb7-e3f3-400d-af8b-c83604ea3313",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "835 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza, garlic knots, and mozzarella sticks. They highlight the good value, fun atmosphere, and the option to buy dough to make pizza at home. They also like the attentive service and the ability to accommodate large groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-b556-714c-8a99-d8e0b93ca4ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b556-714c-8a99-d8e0b93ca4ed",
        "storage_key": "property/6767906449165611/019d7912-b556-714c-8a99-d8e0b93ca4ed.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.hideawaypizza.com/content/moore",
      "poi_directions_map_url": "https://maps.google.com/?cid=11775393291338364643&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "35.320225",
      "poi_longitude": "-97.506918",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-604-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952c-73da-81cf-181f39380d49",
        "storage_key": "property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ--zZQ0ZrsocR47a9TM-ZaqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8567996d-7dfd-46c1-bfba-2b02a10d873f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Ranch Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "2120 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Upscale eatery serving steaks and seafood in elegant quarters.",
      "poi_long_description": "People say this steakhouse serves delicious steaks cooked to perfection, along with great sides and drinks. They also highlight the excellent service and comfortable atmosphere.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-b4da-7621-8749-baf744713c37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-b4da-7621-8749-baf744713c37",
        "storage_key": "property/6767906449165611/019d7912-b4da-7621-8749-baf744713c37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ranchsteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14436837020960911610&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ranch-steakhouse",
      "poi_latitude": "35.2439789",
      "poi_longitude": "-97.480548",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-857-2899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952c-73da-81cf-181f39380d49",
        "storage_key": "property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-gB0IFpsocR-nCV6sfyWcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0c416ff0-e9f0-498d-92d8-72953cf1f345",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Legend's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1313 W Lindsey St, Norman, OK 73069, USA",
      "poi_short_description": "Enduring upscale American eatery plating surf 'n' turf in a low-key atmosphere with a piano player.",
      "poi_long_description": "People say this restaurant offers delicious desserts, well-prepared steaks, and a great wine selection. They highlight the fantastic ambience, live piano music, and attentive service. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-bb49-70e8-a890-f1f225b35954.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bb49-70e8-a890-f1f225b35954",
        "storage_key": "property/6767906449165611/019d7912-bb49-70e8-a890-f1f225b35954.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.legendsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4277388583102165886&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "legend-s-restaurant",
      "poi_latitude": "35.2042555",
      "poi_longitude": "-97.4607651",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-329-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952c-73da-81cf-181f39380d49",
        "storage_key": "property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeKK00posocRfrMd9kBWXDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_81a67c84-2968-4537-8c38-ba1e4e03d621",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Mickey Mantle's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "7 S Mickey Mantle Dr, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Steaks & seafood plus a gluten-free menu, a long wine list & a cigar bar in sophisticated surrounds.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, including Wagyu, and lobster tails. They also highlight the excellent service and attentive staff.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-be2e-74ef-ac14-3b692c02040e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-be2e-74ef-ac14-3b692c02040e",
        "storage_key": "property/6767906449165611/019d7912-be2e-74ef-ac14-3b692c02040e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mickeymantlesteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5413961080801820416&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mickey-mantle-s-steakhouse",
      "poi_latitude": "35.4656259",
      "poi_longitude": "-97.5094534",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-272-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-952c-73da-81cf-181f39380d49",
        "storage_key": "property/6767906449165611/019cfb42-952c-73da-81cf-181f39380d49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYp41yYXsocRAH_7KOtAIks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_23b7ce25-aff5-4fef-bced-37fa140d18c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "501 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Department store chain selling a large assortment of items, including clothing, electronics, and groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products and is well-stocked.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-c035-743b-b10c-1533d004be18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c035-743b-b10c-1533d004be18",
        "storage_key": "property/6767906449165611/019d7912-c035-743b-b10c-1533d004be18.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/277-moore-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1398155659730080411&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.3222198",
      "poi_longitude": "-97.4930648",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-790-0021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9521-735a-b1bf-3cf347bb80dc",
        "storage_key": "property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBRNyzjprsocRm9LpLio_ZxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_80f0f023-15a3-41be-a726-c8ab959348d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "2651 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including organic and whole foods, hearing aids, and clothing. They highlight the great value, competitive prices, and the availability of a food court with a popular turkey sandwich. They also like the clean, well-stocked store, and the friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-bf3e-76c3-913f-fa14339c8585.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-bf3e-76c3-913f-fa14339c8585",
        "storage_key": "property/6767906449165611/019d7912-bf3e-76c3-913f-fa14339c8585.webp",
        "width": 1170,
        "height": 878
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/moore-OK-1444.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2165105340811591480&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "35.3137961",
      "poi_longitude": "-97.4956262",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-300-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9521-735a-b1bf-3cf347bb80dc",
        "storage_key": "property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJcf_QtJrsocROD9gFNb_Cx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_6aa8123b-ad92-4727-a405-c3041c8b5c8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "1705 S Broadway Ave, Moore, OK 73160, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide variety of fruits and other products, including large deck boxes. They also highlight the great deals on quality products, the convenient gas station, and the helpful staff.\n\nSome reviews mention the cafe can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-c65f-7041-81e5-9322b0876244.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c65f-7041-81e5-9322b0876244",
        "storage_key": "property/6767906449165611/019d7912-c65f-7041-81e5-9322b0876244.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.samsclub.com/club/6779-moore-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=389220007204416576&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "35.3224597",
      "poi_longitude": "-97.488358",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-300-6019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9521-735a-b1bf-3cf347bb80dc",
        "storage_key": "property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtTRW9iVrsocRQOzkzIjJZgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3620b581-bb29-4436-a11f-15acce320ddb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "720 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of items. They also highlight the convenience of store pickup.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-c7fe-7119-a7bb-ffc8695db86c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c7fe-7119-a7bb-ffc8695db86c",
        "storage_key": "property/6767906449165611/019d7912-c7fe-7119-a7bb-ffc8695db86c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/moore/2727",
      "poi_directions_map_url": "https://maps.google.com/?cid=17088900174710079013&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.3176847",
      "poi_longitude": "-97.4998724",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-378-5494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9521-735a-b1bf-3cf347bb80dc",
        "storage_key": "property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxT9YezhrsocRJX60Ayv4J-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_273f5bc3-87f3-4d48-b8df-ca8a23c24386",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "790 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Discount department store chain carrying brand-name apparel, home goods, and footwear.",
      "poi_long_description": "People say this clothing store offers a wide selection of clothing and deals. They also highlight the store is clean and well-organized.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-c77f-729b-91be-50feb3d4ff16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c77f-729b-91be-50feb3d4ff16",
        "storage_key": "property/6767906449165611/019d7912-c77f-729b-91be-50feb3d4ff16.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/ok/moore/1102/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16812587680462632101&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "35.3178939",
      "poi_longitude": "-97.5022888",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-676-1499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9521-735a-b1bf-3cf347bb80dc",
        "storage_key": "property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbXBUeolrsocRpXQVIWtPUuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_96b28cf9-5fdb-4e87-87f1-8edfd2ecf4a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "JCPenney",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_long_description": "Chain department store selling a wide selection of brand-name clothing, footwear, furniture & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-cb74-77a9-a566-5faca4345bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cb74-77a9-a566-5faca4345bf1",
        "storage_key": "property/6767906449165611/019d7912-cb74-77a9-a566-5faca4345bf1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jcpenney.com/locations/ok/moore/clothing-stores-moore-ok-2941.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2743159601296766186&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jcpenney",
      "poi_latitude": "35.31588380000001",
      "poi_longitude": "-97.4874005",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-237-1542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9521-735a-b1bf-3cf347bb80dc",
        "storage_key": "property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiVo2I-8UsocR6vR-nR-pESY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3980e4ed-1fcd-451b-a4d2-ebaf67a1baad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2600 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers friendly and helpful staff, and many appreciate the clean and well-organized environment. They also highlight the great customer service and convenient Amazon returns.\n\nSome reviews mention the wait times at the checkout can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-cfd3-7319-99ee-bf4195346299.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cfd3-7319-99ee-bf4195346299",
        "storage_key": "property/6767906449165611/019d7912-cfd3-7319-99ee-bf4195346299.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/moore-490.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17608859687532727802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "35.3143361",
      "poi_longitude": "-97.4934248",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-793-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9521-735a-b1bf-3cf347bb80dc",
        "storage_key": "property/6767906449165611/019cfb42-9521-735a-b1bf-3cf347bb80dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJT8Ba2DxrsocR-o0VD5c8X_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ae0d3fd9-d58d-4f26-9a66-90e26ae1146c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Oklahoma City Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "415 Couch Dr, Oklahoma City, OK 73102, USA",
      "poi_short_description": "American art from the colonial era to 1960, plus European paintings & contemporary exhibitions.",
      "poi_long_description": "People say this art museum offers stunning glass displays, beautiful artwork, and a great gift shop. They highlight the free admission on the second Sunday of the month and the tranquil, relaxing vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-d1bf-7519-ae67-9753b9a15975.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d1bf-7519-ae67-9753b9a15975",
        "storage_key": "property/6767906449165611/019d7912-d1bf-7519-ae67-9753b9a15975.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.okcmoa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9657734537123882826&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-museum-of-art",
      "poi_latitude": "35.4695638",
      "poi_longitude": "-97.5205029",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-236-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9528-75e4-81b6-f15e8a2bef90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9528-75e4-81b6-f15e8a2bef90",
        "storage_key": "property/6767906449165611/019cfb42-9528-75e4-81b6-f15e8a2bef90.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_PiwXsocRSmdKhGQqB4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_251e9940-df19-435b-89a9-0e67e23b7df1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "People say this science museum offers a wide variety of fun, interactive exhibits and activities, including a planetarium and a slanted room. They highlight the educational value, the engaging live shows, and the spacious layout that prevents overcrowding. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-d777-71ef-939d-19546a3bc9c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d777-71ef-939d-19546a3bc9c9",
        "storage_key": "property/6767906449165611/019d7912-d777-71ef-939d-19546a3bc9c9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "17.3 mi",
      "poi_walking_minutes": "6 hours 20 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9528-75e4-81b6-f15e8a2bef90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9528-75e4-81b6-f15e8a2bef90",
        "storage_key": "property/6767906449165611/019cfb42-9528-75e4-81b6-f15e8a2bef90.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a5c49f41-3770-4055-a9c8-819f55947916",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "First Americans Museum",
      "poi_type": "Entertainment",
      "poi_address": "659 First Americans Blvd, Oklahoma City, OK 73129, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this museum offers a wealth of information about the history and culture of Native Americans, with engaging exhibits including videos, artifacts, and oral histories. They also highlight the stunning architecture of the building and the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-d9d3-73ce-bc1a-988646b67dda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d9d3-73ce-bc1a-988646b67dda",
        "storage_key": "property/6767906449165611/019d7912-d9d3-73ce-bc1a-988646b67dda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.famok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1363703120278945108&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "first-americans-museum",
      "poi_latitude": "35.4580352",
      "poi_longitude": "-97.4820974",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-594-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9528-75e4-81b6-f15e8a2bef90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9528-75e4-81b6-f15e8a2bef90",
        "storage_key": "property/6767906449165611/019cfb42-9528-75e4-81b6-f15e8a2bef90.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4b90oEXsocRVH1RP8PY7BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_95131a72-9e63-4c68-af69-3f90ee236272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Adventure District",
      "poi_type": "Entertainment",
      "poi_address": "Adventure District, Oklahoma City, OK 73111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14659867679073690721&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "adventure-district",
      "poi_latitude": "35.52580349999999",
      "poi_longitude": "-97.4765901",
      "poi_miles_from_property": "17.3 mi",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9531-70df-a4d7-a5f0c6dfe90d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9531-70df-a4d7-a5f0c6dfe90d",
        "storage_key": "property/6767906449165611/019cfb42-9531-70df-a4d7-a5f0c6dfe90d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44iK9jUYsocRYeRqmftPcss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8fc3d7df-bd58-4dd2-87ea-95f8a5165606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Yellow Rose Dinner Theater and Events Center",
      "poi_type": "Entertainment",
      "poi_address": "1005 SW 4th St, Moore, OK 73160, USA",
      "poi_short_description": "Singing celebrity impersonators are the forte of this casual theater, also serving American meals.",
      "poi_long_description": "People say this event venue offers a fun experience with phenomenal singing, delicious meals, and scrumptious desserts. They also highlight the friendly staff and the enjoyable atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-e52c-75bb-8beb-4fca5eb8acac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e52c-75bb-8beb-4fca5eb8acac",
        "storage_key": "property/6767906449165611/019d7912-e52c-75bb-8beb-4fca5eb8acac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.yellowrosetheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1782597269970423783&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yellow-rose-dinner-theater-and-events-center",
      "poi_latitude": "35.3350147",
      "poi_longitude": "-97.5097118",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-793-7779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9531-70df-a4d7-a5f0c6dfe90d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9531-70df-a4d7-a5f0c6dfe90d",
        "storage_key": "property/6767906449165611/019cfb42-9531-70df-a4d7-a5f0c6dfe90d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJldHsc7MUsocR5w8rvsUOvRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_e210f123-3081-4c07-897e-e4597a4b17bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "HeyDay Entertainment Norman",
      "poi_type": "Entertainment",
      "poi_address": "3201 Market Pl, Norman, OK 73072, USA",
      "poi_short_description": "Bi-level laser tag arena with bridges & ramps, plus mini-golf, a ropes course, arcade & pizza place.",
      "poi_long_description": "People say this indoor playground offers a variety of fun activities, including mini golf, bowling, laser tag, and arcade games. They also highlight the great service, fun atmosphere, and good food.\n\nOther reviews mention the arcade can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-e942-70eb-8299-90ec8f8330ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e942-70eb-8299-90ec8f8330ec",
        "storage_key": "property/6767906449165611/019d7912-e942-70eb-8299-90ec8f8330ec.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.heydayfun.com/heyday-norman",
      "poi_directions_map_url": "https://maps.google.com/?cid=502273123883228578&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heyday-entertainment-norman",
      "poi_latitude": "35.2940793",
      "poi_longitude": "-97.4896601",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-310-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9531-70df-a4d7-a5f0c6dfe90d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9531-70df-a4d7-a5f0c6dfe90d",
        "storage_key": "property/6767906449165611/019cfb42-9531-70df-a4d7-a5f0c6dfe90d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl5TEAAdrsocRoh1Jub5u-AY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "custom_e8bb4aef-7c5e-4fda-a478-e9f714dde00f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "poi_name": "Belmar Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "1025 E Indian Hills Rd, Norman, OK 73071, USA",
      "poi_short_description": "Members-only golf club featuring a challenging course, pro shop, and clubhouse.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d7912-f35a-707d-99ba-0c1a36e2344f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f35a-707d-99ba-0c1a36e2344f",
        "storage_key": "property/6767906449165611/019d7912-f35a-707d-99ba-0c1a36e2344f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.ilovethiscourse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18193977131381264610&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belmar-golf-club",
      "poi_latitude": "35.2941741",
      "poi_longitude": "-97.4270858",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-364-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-9531-70df-a4d7-a5f0c6dfe90d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb42-9531-70df-a4d7-a5f0c6dfe90d",
        "storage_key": "property/6767906449165611/019cfb42-9531-70df-a4d7-a5f0c6dfe90d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAwI-ttJBsocR4pCPH879ffw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b29e3b605ebd6f0eb49b7f14",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5540947bc3d2fac296d56043",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e106af45b957e2b74f542757",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e2fad8f5e2b8fc894b6a9a38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_65e52f49033dba68fdbfae28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_596968b392d9766907bb5058",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_f3c74607-3a88-4d49-823d-6664bfa16ce3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "rating": "5.0",
      "name": "Haley Armitage",
      "text": "This has been one of my best living experiences to date.   I’ve lived in apts majority of my life and this property is definitely one of the best.   Clean.  Upkeep is phenomenal.   Maintenance requests are ALWAYS answered promptly.   They take your concerns seriously and always address issues with absolute kindness.   Nothing but good things to say about Mission Point property and the entire staff.",
      "date": "2025-09-24",
      "title": ""
    },
    {
      "id": "custom_3730776e-e1d7-4983-b9cd-d31b3e49d81f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "rating": "5.0",
      "name": "A",
      "text": "We asked for our bathroom to be checked for mold, as it was so bad that we couldn’t remove it ourselves.\nThe maintenance staff came in pairs, quickly examined the problem, and said they would return with the necessary tools.\nWhen they came back, they worked quickly and did a neat job. The bathroom looks so clean and white now.\nWe truly appreciate the service and the professionalism of the staff.",
      "date": "2025-08-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a2e5f620-4709-4371-baf5-19fc85872b7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb43-25a6-7699-9975-966c11c8364e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree virtual tour of an apartment complex pool area with lounge chairs and buildings in the background",
        "public_id": "019cfb43-25a6-7699-9975-966c11c8364e",
        "storage_key": "property/6767906449165611/019cfb43-25a6-7699-9975-966c11c8364e.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Mission Point Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62fe309b380f4e40a2374cf7&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-42f3-756c-9951-018117caad94",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "mission-point",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611"
    },
    {
      "lead_collector_id": "019cf79e-4366-726d-b952-d56a8aa4c9b1",
      "lead_source": "LANDING_PAGE",
      "name": "mission-point",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "apartments-with-pool-moore-ok",
      "search_query": "apartments with pool in Moore OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Moore, OK",
      "h2_subtitle": "Dive into luxury at Mission Point. Our Moore, OK apartments offer a sparkling pool and much more for your enjoyment.",
      "page_copy": "Discover the perfect blend of relaxation and modern living at Mission Point, where our apartments with pool in Moore, OK provide the ideal escape from a busy day. Whether you prefer a quick swim or lounging poolside, our sparkling pool adds a touch of elegance and enjoyment to everyday living.\n\nSituated in the lively community of Moore, Mission Point is not just about the pool. Our residents enjoy a full array of amenities, including a fitness center, a business center, and scenic walking trails. Choose from our spacious one- or two-bedroom homes and embrace the convenience of on-site management and innovative package services. It’s time to make Mission Point your new home and dive into a life of luxury and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Moore, OK",
      "seo_description": "Experience luxury with a pool at Mission Point Apartments in Moore, OK. Enjoy modern amenities and vibrant community living. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "dog-park-apartments-moore-ok",
      "search_query": "dog park apartments in Moore OK",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Moore, OK",
      "h2_subtitle": "Pet lovers will find joy at Mission Point. Enjoy spacious dog-friendly apartments in Moore, OK with nearby parks.",
      "page_copy": "At Mission Point, we understand that your pets are family too. That's why our dog park apartments in Moore, OK provide the perfect haven for both you and your furry friends. Enjoy the freedom and space your pets need while you relax in a comfortable and stylish home.\n\nLocated in the thriving community of Moore, our pet-friendly facilities complement an array of premium amenities, including a shimmering pool, a fully-equipped fitness center, and convenient package services. With options for both one- and two-bedroom apartments, you’ll find the perfect fit for your lifestyle at Mission Point. Embrace a community that caters to all members of your household, even the four-legged ones! Schedule a visit today to discover more about our welcoming environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Moore, OK",
      "seo_description": "Find pet-friendly living at Mission Point in Moore, OK. Explore our dog-friendly apartments with top amenities. Perfect for you and your furry friend!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "moore-ok-apartments-with-air-conditioning",
      "search_query": "Moore OK apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Moore, OK Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool at Mission Point, where our apartments in Moore, OK come equipped with air conditioning for absolute comfort.",
      "page_copy": "Beat the Oklahoma heat with ease at Mission Point, where our Moore, OK apartments with air conditioning are designed to ensure your comfort year-round. Revel in a stylish living space that provides a cool retreat during the sweltering summer months, all while enjoying a vibrant community atmosphere.\n\nLocated in the heart of Moore, our one- and two-bedroom apartments offer more than just air conditioning. Relish in premium amenities such as a sparkling pool, a state-of-the-art fitness center, and a scenic walking trail. Add the convenience of our on-site management team and a suite of resident-friendly services, and you’ll see why Mission Point is the ideal choice. Schedule a visit and experience perfect climate control in your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Moore, OK Apartments with Air Conditioning",
      "seo_description": "Enjoy comfort at Mission Point Apartments in Moore, OK. Our homes provide air conditioning and premium amenities for the perfect living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-moore",
      "search_query": "apartments with dishwashers in Moore",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Moore",
      "h2_subtitle": "Discover convenience at Mission Point. Our Moore apartments come with dishwashers, ensuring ease in everyday living.",
      "page_copy": "Simplify your daily routine at Mission Point, where our apartments with dishwashers in Moore provide a blend of practicality and elegance. Enjoy the ease of modern living with kitchen amenities designed to make meal clean-up a breeze, allowing you more time for relaxation and leisure.\n\nNestled in the vibrant community of Moore, Mission Point offers more than just a convenient kitchen; our one- and two-bedroom apartments feature a range of luxurious amenities, including a sparkling swimming pool, a fitness center, and accessible walking trails. With attentive on-site management and comprehensive resident services, you can experience a hassle-free lifestyle. Make Mission Point your choice for modern convenience and quality living today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers in Moore",
      "seo_description": "Experience convenience at Mission Point Apartments in Moore with in-unit dishwashers and premium amenities. Make life easier with modern features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-near-73160",
      "search_query": "in unit laundry apartments near 73160",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments Near 73160",
      "h2_subtitle": "Explore the convenience of Mission Point. Our apartments near 73160 offer the ease of in-unit laundry facilities.",
      "page_copy": "Find ultimate convenience at Mission Point, where our in-unit laundry apartments near 73160 offer the perfect blend of comfort and practicality. Say goodbye to community laundry trips and enjoy the privacy and efficiency of having laundry facilities right inside your home.\n\nSituated in the lively area of Moore, these spacious one- and two-bedroom apartments not only boast in-unit laundry but also feature a range of upscale amenities. With access to a refreshing swimming pool, a modern fitness center, and scenic trails, you'll enjoy an enriched living experience. The professional on-site management ensures you'll have everything you need right at your doorstep. Discover the freedom and ease that Mission Point provides and envision your new lifestyle today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Near 73160",
      "seo_description": "Enjoy in-unit laundry at Mission Point Apartments near 73160. Superior convenience meets modern living with premium amenities and features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-moore-ok",
      "search_query": "1 bedroom apartments moore ok",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Moore, OK",
      "h2_subtitle": "Discover the charm of Mission Point's 1 bedroom apartments in Moore, OK. Enjoy modern living spaces and community amenities.",
      "page_copy": "If you're seeking stylish and comfortable living, explore the 1 bedroom apartments at Mission Point in Moore, OK. These thoughtfully designed spaces offer all the essential comforts of home, perfect for singles or couples who appreciate modern aesthetics combined with day-to-day convenience.\n\nLocated in the vibrant city of Moore, Mission Point provides more than just a home. With community amenities like a refreshing pool, a fully-equipped fitness center, and beautifully maintained walking trails, you’ll find plenty of opportunities to relax and unwind. Experience the added convenience of a professional management team on-site and consider making Mission Point your new home where comfort meets community spirit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Moore, OK",
      "seo_description": "Explore 1 bedroom apartments at Mission Point, Moore, OK. Enjoy modern living with premium amenities, perfect for a cozy lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-cleveland-county",
      "search_query": "2 bedroom apartments cleveland county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Cleveland County",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Mission Point in Cleveland County. Modern living in a vibrant community awaits you.",
      "page_copy": "At Mission Point, discover the perfect blend of style and comfort in our spacious 2 bedroom apartments in Cleveland County. These well-designed living spaces cater to families and roommates looking for ample room paired with top-notch amenities.\n\nLocated in the heart of Moore, our community is part of Cleveland County's flourishing landscape. Enjoy access to our sparkling pool, state-of-the-art fitness center, and picturesque walking trails. With an on-site management team dedicated to resident satisfaction, you'll find the support you need for a truly enjoyable living experience. Choose Mission Point and elevate your lifestyle in a community that offers both convenience and charm.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Cleveland County",
      "seo_description": "Find spacious 2 bedroom apartments at Mission Point in Cleveland County. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "apartments-near-mid-america-christian-university-okc",
      "search_query": "apartments near Mid-America Christian University Oklahoma City",
      "category": "School",
      "h1_title": "Apartments Near Mid-America Christian University",
      "h2_subtitle": "Mission Point offers students and staff comfortable apartments near Mid-America Christian University in Oklahoma City. Discover convenience and style.",
      "page_copy": "Located in the bustling area of Moore, Mission Point provides ideal apartments near Mid-America Christian University, perfect for students and faculty members desiring proximity to campus life. Our community combines modern amenities and a welcoming atmosphere, making it easy to balance work and relaxation.\n\nFeaturing one- and two-bedroom floor plans, these apartments offer more than just a convenient location. You'll enjoy amenities like a sparkling pool, a modern fitness center, and scenic trails for some leisure time. The dedicated on-site management adds an extra layer of convenience, ensuring you have support whenever needed. Embrace a seamless blend of comfort and community at Mission Point, where you can focus on your studies and enjoy a balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mid-America Christian University",
      "seo_description": "Find ideal living at Mission Point near Mid-America Christian University, OKC. Enjoy comfort, convenience, and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "apartments-close-to-randall-university-moore",
      "search_query": "apartments close to Randall University Moore",
      "category": "School",
      "h1_title": "Apartments Close to Randall University",
      "h2_subtitle": "Discover Mission Point's modern apartments close to Randall University, Moore. Enjoy a vibrant community with convenient amenities.",
      "page_copy": "For students and staff seeking quality living nearby, Mission Point offers exceptional apartments close to Randall University in Moore. Our community ensures a blend of convenience and modern comfort, making it an ideal choice for academic life.\n\nWith spacious one- and two-bedroom options, our apartments provide the perfect setting for both study and relaxation. Residents enjoy access to amenities such as a sparkling swimming pool, a comprehensive fitness center, and tranquil walking trails. Plus, with our on-site management team, you'll have the support you need at your fingertips. Choose Mission Point and experience a perfect balance of proximity and lifestyle, tailored to enhance your living experience while studying or working at Randall University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Randall University, Moore",
      "seo_description": "Find modern apartments at Mission Point near Randall University in Moore. Enjoy quality living with amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "apartments-near-norman-regional-hospital-ok",
      "search_query": "apartments near Norman Regional Hospital OK",
      "category": "Hospital",
      "h1_title": "Apartments Near Norman Regional Hospital OK",
      "h2_subtitle": "Explore Mission Point's comfortable apartments near Norman Regional Hospital OK. Enjoy modern living close to work.",
      "page_copy": "Mission Point offers the ideal living solution for healthcare professionals and staff working at Norman Regional Hospital OK. Our conveniently located apartments make commuting a breeze while providing a serene environment to relax after a long day.\n\nChoose from our spacious one- or two-bedroom apartments, equipped with elegant amenities like stainless steel appliances and cable-ready setups. The community boasts a sparkling pool, a state-of-the-art fitness center, and scenic walking trails, providing ample opportunities to unwind. With an on-site property manager, you have peace of mind knowing support is always available. Live close to work while enjoying a vibrant and comfortable community at Mission Point.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Norman Regional Hospital OK",
      "seo_description": "Discover comfortable living at Mission Point, near Norman Regional Hospital OK. Enjoy convenience and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "apartments-close-to-norman-regional-moore-73160",
      "search_query": "apartments close to Norman Regional Moore 73160",
      "category": "Hospital",
      "h1_title": "Apartments Close to Norman Regional Moore",
      "h2_subtitle": "Mission Point offers modern apartments close to Norman Regional Moore in the 73160 area. Experience convenience and comfort.",
      "page_copy": "For professionals and medical staff seeking proximity to Norman Regional Moore, Mission Point provides the ideal apartments in the 73160 area. Our community combines modern living with a convenient location, making it an excellent choice for those working at the hospital.\n\nResidents at Mission Point can select from well-designed one- and two-bedroom layouts, featuring premium amenities like stainless steel appliances and a cable-ready setup. Relax or stay active with our community offerings, including a sparkling pool, fitness center, and scenic walking trails. Plus, our on-site management team is always available, adding an extra layer of convenience. Choose Mission Point for a perfect blend of location, comfort, and lifestyle near Norman Regional Moore.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Norman Regional Moore",
      "seo_description": "Find comfort at Mission Point, offering modern living close to Norman Regional Moore in 73160. Enjoy convenience and relaxation in our vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "apartments-near-buck-thomas-park-moore-ok",
      "search_query": "apartments near Buck Thomas Park Moore OK",
      "category": "Park",
      "h1_title": "Apartments Near Buck Thomas Park Moore OK",
      "h2_subtitle": "Discover Mission Point's inviting apartments near Buck Thomas Park in Moore, OK. Embrace the perfect blend of nature and modern living.",
      "page_copy": "Nestled in the heart of Moore, OK, Mission Point offers beautifully designed apartments near Buck Thomas Park. Ideal for those who love the outdoors, our community provides easy access to nature while offering modern conveniences.\n\nWith spacious one- or two-bedroom apartments available, residents enjoy premium amenities such as stainless steel appliances and cable-ready living spaces. Our community also features a sparkling pool, fitness center, and scenic walking trails, making it easy to maintain an active lifestyle. Additionally, the on-site management team is dedicated to ensuring a comfortable living experience. Choose Mission Point for the perfect mix of nature and modern living, close to Buck Thomas Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Buck Thomas Park Moore OK",
      "seo_description": "Experience nature and modern living at Mission Point, offering apartments near Buck Thomas Park Moore, OK. Enjoy premium amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "apartment-homes-close-to-little-river-park-moore-73160",
      "search_query": "apartment homes close to Little River Park Moore 73160",
      "category": "Park",
      "h1_title": "Apartment Homes Close to Little River Park",
      "h2_subtitle": "Find your dream apartment home close to Little River Park in Moore's 73160 area. Mission Point offers the perfect blend of location and comfort.",
      "page_copy": "Discover Mission Point, where modern apartment homes near Little River Park offer you the ideal living environment in Moore, 73160. Perfectly positioned for those who wish to enjoy both the park's tranquility and the convenience of city life, our community is the place to call home.\n\nChoose from our spacious one- or two-bedroom apartments, each featuring amenities such as stainless steel appliances and ready-to-use cable setups. The community offers a sparkling pool, a fully-equipped fitness center, and scenic walking trails for relaxation and recreation. With an attentive on-site management team, residents experience continuous support and convenience. Embrace the best of both worlds at Mission Point, where nature meets modern comfort near Little River Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Close to Little River Park",
      "seo_description": "Discover modern living at Mission Point, offering apartment homes close to Little River Park in Moore, 73160. Enjoy convenience and comfort in a vibrant setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "living-near-sutton-wilderness-trail-park-cleveland-county",
      "search_query": "living near Sutton Wilderness Trail Park Cleveland County",
      "category": "Park",
      "h1_title": "Living Near Sutton Wilderness Trail Park",
      "h2_subtitle": "Experience the serenity of living near Sutton Wilderness Trail Park in Cleveland County. Mission Point combines nature with modern comforts.",
      "page_copy": "Mission Point offers an exceptional living experience near Sutton Wilderness Trail Park, in the heart of Cleveland County. Whether you're an avid nature lover or looking for a tranquil retreat, our community provides seamless access to the beautiful trails and natural views of Sutton Wilderness.\n\nOur one- and two-bedroom apartments feature contemporary amenities such as stainless steel appliances and are cable ready. Residents can also unwind in the sparkling pool, stay fit in the on-site fitness center, or enjoy scenic walks within our community. With a dedicated on-site management team ensuring your every need is met, living at Mission Point gives you the perfect balance of nature and urban amenities, all close to Sutton Wilderness Trail Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Sutton Wilderness Trail Park",
      "seo_description": "Enjoy the blend of nature and modern amenities at Mission Point, near Sutton Wilderness Trail Park in Cleveland County. A perfect place for nature enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165611",
      "source": "generator",
      "page_item_url": "new-apartments-by-ruby-grant-park-moore-ok",
      "search_query": "new apartments by Ruby Grant Park Moore OK",
      "category": "Park",
      "h1_title": "New Apartments by Ruby Grant Park Moore OK",
      "h2_subtitle": "Explore new apartments by Ruby Grant Park in Moore, OK. Mission Point offers a modern lifestyle with fantastic amenities.",
      "page_copy": "Welcome to Mission Point, where new apartments by Ruby Grant Park in Moore, OK, provide an unparalleled living experience. Situated near one of the region's most beloved green spaces, our community offers a perfect mix of tranquility and modern living.\n\nEnjoy spacious one- or two-bedroom apartment options, complete with elegant amenities including stainless steel appliances and cable-ready setups. Residents can take advantage of the on-site fitness center, bask in the sun by the sparkling pool, or explore our scenic walking trails. With our attentive property management team on-site, you’ll have both the peace of nature and the convenience of contemporary living at your fingertips. Experience the new standard of apartment living near Ruby Grant Park at Mission Point.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
      "featured_image_media": {
        "alt_text": "Elegant community lobby with seating areas and a reception desk.",
        "public_id": "019cfb42-6f3f-7102-b869-9c5acc54fe3b",
        "storage_key": "property/6767906449165611/019cfb42-6f3f-7102-b869-9c5acc54fe3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "New Apartments by Ruby Grant Park Moore OK",
      "seo_description": "Discover new apartments at Mission Point near Ruby Grant Park, Moore OK. Enjoy modern living with amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5185"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-32THVW85TV"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151267"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/mission-point/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WVXKR26Q"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d1bd8-aff2-740d-b950-1a1ab5e9a243.webp"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "eedefab1-d403-4743-81e9-5e052a684fc0"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-720-7161"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64ac4eee8eccd96eb7060dd6"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im9PUWVTVkRiWnk2aTMzQnMxbmhzekE9PSIsInZhbHVlIjoiZGFrYk1MWUliVVNUK3JxdWprblZhZz09IiwibWFjIjoiYjQwNTE1NGVmOTllOWI3MDM3OTdlMzBhOTQ5ZmRmNTQ5ZWU4MTJhYjc4MDQzOTkzNzkzMzRkZTM5MTEwOTM1MyJ9"
    }
  ],
  "custom_qb_id": "5185",
  "custom_ga4_id": "G-32THVW85TV",
  "custom_repli_id": "10041151267",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/mission-point/register/",
  "custom_google_gtm_id": "GTM-WVXKR26Q",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019d1bd8-aff2-740d-b950-1a1ab5e9a243.webp",
  "custom_rentgrata_property_id": "eedefab1-d403-4743-81e9-5e052a684fc0",
  "custom_ppc_tracking_phone_number": "888-720-7161",
  "custom_residentboost_apartment_id": "64ac4eee8eccd96eb7060dd6",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im9PUWVTVkRiWnk2aTMzQnMxbmhzekE9PSIsInZhbHVlIjoiZGFrYk1MWUliVVNUK3JxdWprblZhZz09IiwibWFjIjoiYjQwNTE1NGVmOTllOWI3MDM3OTdlMzBhOTQ5ZmRmNTQ5ZWU4MTJhYjc4MDQzOTkzNzkzMzRkZTM5MTEwOTM1MyJ9"
};

export const generatedAt = '2026-08-27T21:37:55.164Z';
